import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { AppShell, PageContainer } from '../../features/ui-system';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  AlertTriangle, Calendar, Check, Clock, CreditCard, DollarSign,
  Download, FileText, History, Home, Map, MessageSquare, Network, Newspaper, Paperclip,
  Phone, Plus, RefreshCw, RotateCcw, Search, Send, Settings, Trash2, TrendingUp, Users, Wrench
} from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { toast } from 'sonner';
import axios from 'axios';
import ktcLogo from '../../assets/ktc.png';
import { resolveBackendBaseUrl } from '../../utils/runtimeConfig';
import StaffPageLoadingOverlay from '../../components/StaffPageLoadingOverlay';
import StaffPageHeader from '../../components/StaffPageHeader';

const API = `${resolveBackendBaseUrl()}/api`;
const BASE_URL = `${resolveBackendBaseUrl()}`.replace(/\/$/, '');

const BILLING_ACTIVITY_ACTIONS = new Set([
  'billing.auto_suspend_overdue',
  'billing.auto_reactivate_cleared',
  'billing.manual_reconcile_overdue',
  'billing.manual_reactivate_cleared',
]);

const BILLING_ACTIVITY_LABELS = {
  'billing.auto_suspend_overdue': 'Suspend Otomatis',
  'billing.auto_reactivate_cleared': 'Reaktivasi Otomatis',
  'billing.manual_reconcile_overdue': 'Rekonsiliasi Manual',
  'billing.manual_reactivate_cleared': 'Reaktivasi Manual',
};

const AdminBilling = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [billings, setBillings] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [stats, setStats] = useState({});
  const [incomeFull, setIncomeFull] = useState({});
  const [loadingIncomeFull, setLoadingIncomeFull] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('');
  const [filterMonth, setFilterMonth] = useState('');
  const [filterYear, setFilterYear] = useState(new Date().getFullYear().toString());
  const [filterBukti, setFilterBukti] = useState('');
  const [filterPaymentMethod, setFilterPaymentMethod] = useState('all');
  const [printMode, setPrintMode] = useState('standard');
  const [billingSearchQuery, setBillingSearchQuery] = useState('');
  const [billingView, setBillingView] = useState('all');
  const [invoiceFocus, setTagihanFocus] = useState('operational');
  const [billingWorkspaceTab, setBillingWorkspaceTab] = useState('pelanggan');
  const [billingPage, setBillingPage] = useState(1);
  const [billingPerPage, setBillingPerPage] = useState(20);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isGenerateModalOpen, setIsGenerateModalOpen] = useState(false);
  const [generateMonth, setGenerateMonth] = useState((new Date().getMonth() + 1).toString());
  const [generateYear, setGenerateYear] = useState(new Date().getFullYear().toString());
  const [formData, setFormData] = useState({
    customer_id: '',
    period_month: '',
    period_year: new Date().getFullYear().toString(),
    amount: '',
    notes: ''
  });
  const [overdueControl, setTertunggakControl] = useState({ summary: {}, eligible_suspend_customers: [], reactivation_candidates: [], policy: {} });
  const [loadingTertunggakControl, setLoadingTertunggakControl] = useState(false);
  const [reconcilingTertunggak, setReconcilingTertunggak] = useState(false);
  const [reactivatingCleared, setReactivatingCleared] = useState(false);
  const [billingActivityLogs, setBillingActivityLogs] = useState([]);
  const [loadingBillingActivityLogs, setLoadingBillingActivityLogs] = useState(false);
  const [overdueSearchQuery, setTertunggakSearchQuery] = useState('');
  const [payingBillingId, setPayingBillingId] = useState('');
  const [creatingGatewayPayment, setCreatingGatewayPayment] = useState(false);
  const [gatewayProvider, setGatewayProvider] = useState('xendit');
  const [gatewayChannel, setGatewayChannel] = useState('va_bca');
  const [gatewayBillingId, setGatewayBillingId] = useState('');
  const [gatewayTransactions, setGatewayTransactions] = useState([]);
  const [loadingGatewayTransactions, setLoadingGatewayTransactions] = useState(false);
  const [simulatingGatewayTxId, setSimulatingGatewayTxId] = useState('');
  const [billingPaymentMethodMap, setBillingPaymentMethodMap] = useState({});
  const [billingPaymentSourceMap, setBillingPaymentSourceMap] = useState({});
  const [billingPaymentNoteMap, setBillingPaymentNoteMap] = useState({});
  const [billingPaymentBuktiFileMap, setBillingPaymentBuktiFileMap] = useState({});
  const [transferSubmissions, setTransferSubmissions] = useState([]);
  const [loadingTransferSubmissions, setLoadingTransferSubmissions] = useState(false);
  const [payments, setPayments] = useState([]);
  const [loadingPayments, setLoadingPayments] = useState(false);
  const [billingEvents, setBillingEvents] = useState([]);
  const [loadingBillingEvents, setLoadingBillingEvents] = useState(false);
  const [processingTransferSubmissionId, setProcessingTransferSubmissionId] = useState('');
  const [selectedTransferSubmissionIds, setSelectedTransferSubmissionIds] = useState([]);
  const [transferSubmissionSearch, setTransferSubmissionSearch] = useState('');
  const [batchApprovingTransfers, setBatchApprovingTransfers] = useState(false);
  const [freeradiusSyncSummary, setFreeradiusSyncSummary] = useState({ summary: {}, items: [] });
  const [loadingFreeradiusSyncSummary, setLoadingFreeradiusSyncSummary] = useState(false);
  const [freeradiusQueue, setFreeradiusQueue] = useState({ summary: {}, items: [] });
  const [freeradiusQueueGuard, setFreeradiusQueueGuard] = useState({ paused: false, consecutive_failures: 0, pause_threshold: 5 });
  const [freeradiusGuardSettings, setFreeradiusGuardSettings] = useState({ pause_threshold: 5, paused: false });
  const [savingFreeradiusGuard, setSavingFreeradiusGuard] = useState(false);
  const [loadingFreeradiusMetrics, setLoadingFreeradiusMetrics] = useState(false);
  const [freeradiusMetrics, setFreeradiusMetrics] = useState([]);
  const [loadingFreeradiusQueue, setLoadingFreeradiusQueue] = useState(false);
  const [enqueueingFreeradiusSync, setEnqueueingFreeradiusSync] = useState(false);
  const [retryingQueueId, setRetryingQueueId] = useState('');
  const [retryingAllQueues, setRetryingAllQueues] = useState(false);
  const [resumingQueue, setResumingQueue] = useState(false);
  const [pausingQueue, setPausingQueue] = useState(false);
  const [metricsRangeHours, setMetricsRangeHours] = useState('24');
  const [queueStatusFilter, setQueueStatusFilter] = useState('all');
  const [isolationLogs, setIsolationLogs] = useState([]);
  const [loadingIsolationLogs, setLoadingIsolationLogs] = useState(false);
  const [systemMetrics, setSystemMetrics] = useState(null);
  const [billingSearchSourceLabel, setBillingSearchSourceLabel] = useState('');
  const queueStatusMapRef = useRef({});
  const queueStatusReadyRef = useRef(false);
  const queryInitRef = useRef(false);

  const months = [
    { value: '1', label: 'Januari' }, { value: '2', label: 'Februari' },
    { value: '3', label: 'Maret' }, { value: '4', label: 'April' },
    { value: '5', label: 'Mei' }, { value: '6', label: 'Juni' },
    { value: '7', label: 'Juli' }, { value: '8', label: 'Agustus' },
    { value: '9', label: 'September' }, { value: '10', label: 'Oktober' },
    { value: '11', label: 'November' }, { value: '12', label: 'Desember' }
  ];

  const statusColors = {
    paid: 'ktc-status-badge ktc-status-online',
    unpaid: 'ktc-status-badge ktc-status-warning',
    overjatuh_tempo: 'ktc-status-badge ktc-status-offline'
  };

  const statusIcons = {
    paid: Check,
    unpaid: Clock,
    overjatuh_tempo: AlertTriangle
  };

  const normalizeKey = (value) => String(value || '').trim().toLowerCase();


  const getAuthHeaders = useCallback(() => {
    const token = localStorage.getItem('ktc_token');
    return { Authorization: `Bearer ${token}` };
  }, []);

  const fetchBillings = useCallback(async () => {
    try {
      setLoading(true);
      const params = {};
      if (filterStatus) params.status = filterStatus;
      if (filterMonth) params.month = parseInt(filterMonth);
      if (filterYear) params.year = parseInt(filterYear);

      const response = await axios.get(`${API}/billings`, { headers: getAuthHeaders(), params });
      const data = Array.isArray(response.data) ? response.data : [];
      setBillings(data);
    } catch (error) {
      toast.error('Gagal memuat data tagihan');
      setBillings([]);
    } finally {
      setLoading(false);
    }
  }, [filterStatus, filterMonth, filterYear, getAuthHeaders]);

  const fetchCustomers = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/customers`, { headers: getAuthHeaders(), params: { status: 'active' } });
      setCustomers(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      setCustomers([]);
    }
  }, [getAuthHeaders]);

  const fetchStats = useCallback(async () => {
    try {
      const params = {};
      if (filterMonth) params.month = parseInt(filterMonth);
      if (filterYear) params.year = parseInt(filterYear);

      const response = await axios.get(`${API}/billings/stats/summary`, { headers: getAuthHeaders(), params });
      setStats(response.data);
    } catch (error) {
      setStats({});
    }
  }, [filterMonth, filterYear, getAuthHeaders]);

  const fetchIncomeFull = useCallback(async () => {
    setLoadingIncomeFull(true);
    try {
      const params = {};
      if (filterMonth) params.month = parseInt(filterMonth);
      if (filterYear) params.year = parseInt(filterYear);
      const response = await axios.get(`${API}/reports/income/monthly-full`, { headers: getAuthHeaders(), params });
      setIncomeFull(response.data && typeof response.data === 'object' ? response.data : {});
    } catch (error) {
      setIncomeFull({});
    } finally {
      setLoadingIncomeFull(false);
    }
  }, [filterMonth, filterYear, getAuthHeaders]);

  const fetchTertunggakControl = useCallback(async () => {
    setLoadingTertunggakControl(true);
    try {
      const response = await axios.get(`${API}/billings/overdue/reconciliation-status`, { headers: getAuthHeaders() });
      setTertunggakControl(response.data && typeof response.data === 'object' ? response.data : { summary: {}, eligible_suspend_customers: [], reactivation_candidates: [], policy: {} });
    } catch (error) {
      setTertunggakControl({ summary: {}, eligible_suspend_customers: [], reactivation_candidates: [], policy: {} });
    } finally {
      setLoadingTertunggakControl(false);
    }
  }, [getAuthHeaders]);

  const fetchBillingActivityLogs = useCallback(async () => {
    setLoadingBillingActivityLogs(true);
    try {
      const response = await axios.get(`${API}/activity-logs`, { headers: getAuthHeaders(), params: { category: 'billing', limit: 30 } });
      const logs = Array.isArray(response.data?.logs) ? response.data.logs : [];
      setBillingActivityLogs(logs.filter((item) => BILLING_ACTIVITY_ACTIONS.has(item?.action)).slice(0, 10));
    } catch (error) {
      setBillingActivityLogs([]);
    } finally {
      setLoadingBillingActivityLogs(false);
    }
  }, [getAuthHeaders]);

  const fetchFreeradiusSyncSummary = useCallback(async () => {
    setLoadingFreeradiusSyncSummary(true);
    try {
      const response = await axios.get(`${API}/freeradius/sync-summary`, { headers: getAuthHeaders(), params: { limit: 30 } });
      const payload = response.data && typeof response.data === 'object' ? response.data : {};
      setFreeradiusSyncSummary({
        summary: payload.summary && typeof payload.summary === 'object' ? payload.summary : {},
        items: Array.isArray(payload.items) ? payload.items : [],
      });
    } catch (error) {
      setFreeradiusSyncSummary({ summary: {}, items: [] });
    } finally {
      setLoadingFreeradiusSyncSummary(false);
    }
  }, [getAuthHeaders]);

  const fetchFreeradiusQueue = useCallback(async () => {
    setLoadingFreeradiusQueue(true);
    try {
      const params = { limit: 30 };
      if (queueStatusFilter && queueStatusFilter !== 'all') params.status = queueStatusFilter;
      const response = await axios.get(`${API}/freeradius/sync-queue`, { headers: getAuthHeaders(), params });
      const payload = response.data && typeof response.data === 'object' ? response.data : {};
      const items = Array.isArray(payload.items) ? payload.items : [];
      const nextStatusMap = {};
      items.forEach((item) => {
        if (!item?.id) return;
        const queueId = String(item.id);
        const status = String(item.status || '');
        nextStatusMap[queueId] = status;
        if (queueStatusReadyRef.current) {
          const previous = queueStatusMapRef.current[queueId];
          if (previous && previous !== status) {
            if (status === 'success') {
              toast.success(`Queue ${queueId.slice(0, 8)} berhasil diproses`);
            } else if (status === 'failed') {
              toast.error(`Queue ${queueId.slice(0, 8)} gagal diproses`);
            }
          }
        }
      });
      queueStatusMapRef.current = nextStatusMap;
      queueStatusReadyRef.current = true;
      const guard = payload.guard && typeof payload.guard === 'object' ? payload.guard : {};
      setFreeradiusQueueGuard({
        paused: Boolean(guard.paused || payload.summary?.paused),
        consecutive_failures: Number(guard.consecutive_failures ?? payload.summary?.consecutive_failures ?? 0),
        pause_threshold: Number(guard.pause_threshold ?? payload.summary?.pause_threshold ?? 5),
      });
      setFreeradiusQueue({
        summary: payload.summary && typeof payload.summary === 'object' ? payload.summary : {},
        items,
      });
    } catch (error) {
      setFreeradiusQueue({ summary: {}, items: [] });
    } finally {
      setLoadingFreeradiusQueue(false);
    }
  }, [getAuthHeaders, queueStatusFilter]);

  const fetchFreeradiusGuardSettings = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/settings/freeradius/sync-guard`, { headers: getAuthHeaders() });
      const payload = response.data && typeof response.data === 'object' ? response.data : {};
      setFreeradiusGuardSettings({
        pause_threshold: Number(payload.pause_threshold || 5),
        paused: Boolean(payload.paused),
      });
    } catch (error) {
      setFreeradiusGuardSettings({ pause_threshold: 5, paused: false });
    }
  }, [getAuthHeaders]);

  const fetchFreeradiusQueueMetrics = useCallback(async () => {
    setLoadingFreeradiusMetrics(true);
    try {
      const safeHours = Number(metricsRangeHours || 24);
      const response = await axios.get(`${API}/freeradius/sync-queue/metrics`, {
        headers: getAuthHeaders(),
        params: { hours: safeHours },
      });
      const series = Array.isArray(response.data?.series) ? response.data.series : [];
      setFreeradiusMetrics(series);
    } catch (error) {
      setFreeradiusMetrics([]);
    } finally {
      setLoadingFreeradiusMetrics(false);
    }
  }, [getAuthHeaders, metricsRangeHours]);

  const fetchIsolationLogs = useCallback(async () => {
    setLoadingIsolationLogs(true);
    try {
      const response = await axios.get(`${API}/billings/overdue/isolation-logs`, { headers: getAuthHeaders(), params: { limit: 30 } });
      const payload = response.data && typeof response.data === 'object' ? response.data : {};
      setIsolationLogs(Array.isArray(payload.items) ? payload.items : []);
    } catch (error) {
      setIsolationLogs([]);
    } finally {
      setLoadingIsolationLogs(false);
    }
  }, [getAuthHeaders]);

  const fetchGatewayTransactions = useCallback(async () => {
    setLoadingGatewayTransactions(true);
    try {
      const response = await axios.get(`${API}/payments/gateway/transactions`, {
        headers: getAuthHeaders(),
        params: { limit: 20 },
      });
      const payload = response.data && typeof response.data === 'object' ? response.data : {};
      setGatewayTransactions(Array.isArray(payload.items) ? payload.items : []);
    } catch (error) {
      setGatewayTransactions([]);
    } finally {
      setLoadingGatewayTransactions(false);
    }
  }, [getAuthHeaders]);

  const fetchTransferSubmissions = useCallback(async () => {
    setLoadingTransferSubmissions(true);
    try {
      const response = await axios.get(`${API}/payments/transfer-submissions`, {
        headers: getAuthHeaders(),
        params: { limit: 30, status: 'pending' },
      });
      setTransferSubmissions(Array.isArray(response.data?.items) ? response.data.items : []);
      setSelectedTransferSubmissionIds([]);
    } catch (error) {
      setTransferSubmissions([]);
      setSelectedTransferSubmissionIds([]);
    } finally {
      setLoadingTransferSubmissions(false);
    }
  }, [getAuthHeaders]);

  const fetchPayments = useCallback(async () => {
    setLoadingPayments(true);
    try {
      const response = await axios.get(`${API}/payments`, {
        headers: getAuthHeaders(),
        params: { limit: 300 },
      });
      const payload = response.data && typeof response.data === 'object' ? response.data : {};
      setPayments(Array.isArray(payload.items) ? payload.items : []);
    } catch (error) {
      setPayments([]);
    } finally {
      setLoadingPayments(false);
    }
  }, [getAuthHeaders]);

  const fetchBillingEvents = useCallback(async () => {
    setLoadingBillingEvents(true);
    try {
      const response = await axios.get(`${API}/billings/events`, {
        headers: getAuthHeaders(),
        params: { limit: 300 },
      });
      const payload = response.data && typeof response.data === 'object' ? response.data : {};
      setBillingEvents(Array.isArray(payload.items) ? payload.items : []);
    } catch (error) {
      setBillingEvents([]);
    } finally {
      setLoadingBillingEvents(false);
    }
  }, [getAuthHeaders]);

  const fetchSystemMetrics = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/system/metrics`, { headers: getAuthHeaders() });
      setSystemMetrics(response.data && typeof response.data === 'object' ? response.data : null);
    } catch (error) {
      setSystemMetrics(null);
    }
  }, [getAuthHeaders]);

  const handleSyncWithLog = async () => {
    setEnqueueingFreeradiusSync(true);
    try {
      const response = await axios.post(`${API}/freeradius/sync-enqueue`, {}, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Sinkronisasi FreeRADIUS masuk antrean');
      fetchFreeradiusQueue();
      fetchFreeradiusSyncSummary();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal menambahkan antrean sinkronisasi FreeRADIUS');
    } finally {
      setEnqueueingFreeradiusSync(false);
    }
  };

  const handleRetryQueueJob = async (queueId) => {
    if (!queueId) return;
    setRetryingQueueId(queueId);
    try {
      const response = await axios.post(`${API}/freeradius/sync-queue/${queueId}/retry`, {}, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Queue dijadwalkan ulang');
      fetchFreeradiusQueue();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal retry queue');
    } finally {
      setRetryingQueueId('');
    }
  };

  const handleRetryAllFailedQueues = async () => {
    setRetryingAllQueues(true);
    try {
      const response = await axios.post(`${API}/freeradius/sync-queue/retry-failed`, {}, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Queue gagal dijadwalkan ulang');
      fetchFreeradiusQueue();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal retry semua queue');
    } finally {
      setRetryingAllQueues(false);
    }
  };

  const handleResumeFreeradiusQueue = async () => {
    setResumingQueue(true);
    try {
      const response = await axios.post(`${API}/freeradius/sync-queue/resume`, {}, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Queue FreeRADIUS dilanjutkan');
      fetchFreeradiusQueue();
      fetchFreeradiusGuardSettings();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal melanjutkan queue FreeRADIUS');
    } finally {
      setResumingQueue(false);
    }
  };

  const handlePauseFreeradiusQueue = async () => {
    setPausingQueue(true);
    try {
      const payload = {
        pause_threshold: Number(freeradiusGuardSettings.pause_threshold || 5),
        paused: true,
        pause_reason: 'manual',
      };
      const response = await axios.post(`${API}/settings/freeradius/sync-guard`, payload, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Queue FreeRADIUS dipause manual');
      fetchFreeradiusQueue();
      fetchFreeradiusGuardSettings();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal pause queue FreeRADIUS');
    } finally {
      setPausingQueue(false);
    }
  };

  const handleExportFreeradiusQueueCsv = async () => {
    try {
      const params = { limit: 1000 };
      if (queueStatusFilter && queueStatusFilter !== 'all') params.status = queueStatusFilter;
      const response = await axios.get(`${API}/freeradius/sync-queue/export.csv`, {
        headers: getAuthHeaders(),
        params,
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `freeradius-sync-queue-${new Date().toISOString().replace(/[:.]/g, '-')}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal mengekspor CSV antrean');
    }
  };

  const handleSaveFreeradiusGuardSettings = async () => {
    setSavingFreeradiusGuard(true);
    try {
      const payload = {
        pause_threshold: Number(freeradiusGuardSettings.pause_threshold || 5),
      };
      const response = await axios.post(`${API}/settings/freeradius/sync-guard`, payload, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Pengaturan guard tersimpan');
      fetchFreeradiusQueue();
      fetchFreeradiusGuardSettings();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal menyimpan pengaturan guard');
    } finally {
      setSavingFreeradiusGuard(false);
    }
  };

  const handleCreateGatewayPayment = async () => {
    if (!gatewayBillingId) {
      toast.error('Pilih tagihan dulu');
      return;
    }
    setCreatingGatewayPayment(true);
    try {
      const response = await axios.post(`${API}/payments/gateway/create`, {
        billing_id: gatewayBillingId,
        provider: gatewayProvider,
        channel: gatewayChannel,
      }, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Virtual account berhasil dibuat');
      fetchGatewayTransactions();
      fetchBillings();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal membuat pembayaran gateway');
    } finally {
      setCreatingGatewayPayment(false);
    }
  };

  const handleSimulateGatewayPaid = async (transactionId) => {
    if (!transactionId) return;
    setSimulatingGatewayTxId(transactionId);
    try {
      const response = await axios.post(`${API}/payments/gateway/${transactionId}/simulate-paid`, { paid: true }, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Pembayaran gateway diproses');
      fetchGatewayTransactions();
      refreshBillingData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal memproses pembayaran gateway');
    } finally {
      setSimulatingGatewayTxId('');
    }
  };

  const handleSetujuiTransferSubmission = async (submissionId) => {
    if (!submissionId) return;
    setProcessingTransferSubmissionId(submissionId);
    try {
      const response = await axios.post(`${API}/payments/transfer-submissions/${submissionId}/approve`, {}, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Transfer disetujui');
      fetchTransferSubmissions();
      refreshBillingData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal approve transfer');
    } finally {
      setProcessingTransferSubmissionId('');
    }
  };

  const handleTolakTransferSubmission = async (submissionId) => {
    if (!submissionId) return;
    const reason = window.prompt('Alasan reject bukti transfer (opsional):', '') || '';
    setProcessingTransferSubmissionId(submissionId);
    try {
      const form = new FormData();
      form.append('note', reason);
      const response = await axios.post(`${API}/payments/transfer-submissions/${submissionId}/reject`, form, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Transfer ditolak');
      fetchTransferSubmissions();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal reject transfer');
    } finally {
      setProcessingTransferSubmissionId('');
    }
  };

  const handleToggleTransferSelection = (submissionId) => {
    if (!submissionId) return;
    setSelectedTransferSubmissionIds((prev) => {
      const id = String(submissionId);
      if (prev.includes(id)) return prev.filter((item) => item !== id);
      return [...prev, id];
    });
  };

  const handleToggleSelectAllTransfer = () => {
    const visibleIds = filteredTransferSubmissions.map((item) => String(item.id));
    if (!visibleIds.length) return;
    const allSelected = visibleIds.every((id) => selectedTransferSubmissionIds.includes(id));
    if (allSelected) {
      setSelectedTransferSubmissionIds((prev) => prev.filter((id) => !visibleIds.includes(id)));
      return;
    }
    setSelectedTransferSubmissionIds((prev) => Array.from(new Set([...prev, ...visibleIds])));
  };

  const handleSetujuiTransferBatch = async () => {
    const targetIds = selectedTransferSubmissionIds.filter((id) => filteredTransferSubmissions.some((item) => String(item.id) === String(id)));
    if (!targetIds.length || batchApprovingTransfers) return;
    if (!window.confirm(`Setujui ${targetIds.length} bukti transfer terpilih?`)) return;
    setBatchApprovingTransfers(true);
    let successCount = 0;
    let failedCount = 0;
    for (const submissionId of targetIds) {
      try {
        await axios.post(`${API}/payments/transfer-submissions/${submissionId}/approve`, {}, { headers: getAuthHeaders() });
        successCount += 1;
      } catch (error) {
        failedCount += 1;
      }
    }
    if (successCount > 0) {
      toast.success(`Berhasil approve ${successCount} transfer.`);
    }
    if (failedCount > 0) {
      toast.error(`${failedCount} transfer gagal di-approve.`);
    }
    setBatchApprovingTransfers(false);
    fetchTransferSubmissions();
    refreshBillingData();
  };
  useEffect(() => {
    const storedUser = localStorage.getItem('ktc_user');
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  useEffect(() => {
    if (queryInitRef.current) return;
    const params = new URLSearchParams(location.search || '');
    const customerId = String(params.get('customer_id') || '').trim();
    const source = String(params.get('source') || '').trim();
    if (customerId) {
      setBillingSearchQuery(customerId);
      setBillingSearchSourceLabel(source === 'customers' ? 'Filter dari menu Pelanggan' : 'Filter dari tautan');
    }
    queryInitRef.current = true;
  }, [location.search]);

  useEffect(() => {
    fetchBillings();
    fetchCustomers();
    fetchStats();
    fetchIncomeFull();
    fetchTertunggakControl();
    fetchBillingActivityLogs();
    fetchFreeradiusSyncSummary();
    fetchFreeradiusQueue();
    fetchFreeradiusGuardSettings();
    fetchFreeradiusQueueMetrics();
    fetchIsolationLogs();
    fetchGatewayTransactions();
    fetchTransferSubmissions();
    fetchPayments();
    fetchBillingEvents();
    fetchSystemMetrics();
  }, [fetchBillings, fetchCustomers, fetchStats, fetchIncomeFull, fetchTertunggakControl, fetchBillingActivityLogs, fetchFreeradiusSyncSummary, fetchFreeradiusQueue, fetchFreeradiusGuardSettings, fetchFreeradiusQueueMetrics, fetchIsolationLogs, fetchGatewayTransactions, fetchTransferSubmissions, fetchPayments, fetchBillingEvents, fetchSystemMetrics]);

  useEffect(() => {
    const timer = setInterval(() => {
      fetchFreeradiusQueue();
      fetchFreeradiusSyncSummary();
      fetchFreeradiusQueueMetrics();
      fetchGatewayTransactions();
      fetchTransferSubmissions();
      fetchPayments();
      fetchBillingEvents();
      fetchSystemMetrics();
    }, 10000);
    return () => clearInterval(timer);
  }, [fetchFreeradiusQueue, fetchFreeradiusSyncSummary, fetchFreeradiusQueueMetrics, fetchGatewayTransactions, fetchTransferSubmissions, fetchPayments, fetchBillingEvents, fetchSystemMetrics]);

  const refreshBillingData = useCallback(() => {
    fetchBillings();
    fetchCustomers();
    fetchStats();
    fetchIncomeFull();
    fetchTertunggakControl();
    fetchBillingActivityLogs();
    fetchFreeradiusSyncSummary();
    fetchFreeradiusQueue();
    fetchIsolationLogs();
    fetchGatewayTransactions();
    fetchTransferSubmissions();
    fetchPayments();
    fetchBillingEvents();
    fetchSystemMetrics();
  }, [fetchBillings, fetchCustomers, fetchStats, fetchIncomeFull, fetchTertunggakControl, fetchBillingActivityLogs, fetchFreeradiusSyncSummary, fetchFreeradiusQueue, fetchIsolationLogs, fetchGatewayTransactions, fetchTransferSubmissions, fetchPayments, fetchBillingEvents, fetchSystemMetrics]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      await axios.post(`${API}/billings`, {
        customer_id: formData.customer_id,
        period_month: parseInt(formData.period_month),
        period_year: parseInt(formData.period_year),
        amount: formData.amount ? parseInt(formData.amount) : null,
        notes: formData.notes || null
      }, { headers: getAuthHeaders() });
      
      toast.success('Tagihan berhasil dibuat!');
      setIsModalOpen(false);
      setFormData({ customer_id: '', period_month: '', period_year: new Date().getFullYear().toString(), amount: '', notes: '' });
      refreshBillingData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal membuat tagihan');
    }
  };

  const handleGenerateMonthly = async () => {
    try {
      const response = await axios.post(`${API}/billings/generate-monthly`, null, {
        headers: getAuthHeaders(),
        params: { month: parseInt(generateMonth), year: parseInt(generateYear) }
      });
      toast.success(response.data.message);
      setIsGenerateModalOpen(false);
      refreshBillingData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal generate tagihan');
    }
  };

  const handlePayment = async (billingId, method = 'cash') => {
    if (!billingId || payingBillingId === billingId) return;
    setPayingBillingId(billingId);
    try {
      const idempotencyKey = `${billingId}:${method}:${Date.now()}:${Math.random().toString(36).slice(2, 10)}`;
      const paymentChannel = method === 'transfer' ? 'manual-transfer' : 'manual-cash';
      const paymentSource = String(billingPaymentSourceMap[billingId] || (method === 'transfer' ? 'wa' : 'office'));
      const note = String(billingPaymentNoteMap[billingId] || '').trim();
      const proofFile = billingPaymentBuktiFileMap[billingId] || null;
      if (proofFile || note) {
        const form = new FormData();
        form.append('payment_method', method);
        form.append('payment_channel', paymentChannel);
        form.append('payment_source', paymentSource);
        if (note) form.append('payment_note', note);
        if (proofFile) form.append('proof_file', proofFile);
        await axios.post(`${API}/billings/${billingId}/pay-with-proof`, form, {
          headers: {
            ...getAuthHeaders(),
            'X-Idempotency-Key': idempotencyKey,
          },
        });
      } else {
        await axios.put(`${API}/billings/${billingId}/pay`, null, {
          headers: {
            ...getAuthHeaders(),
            'X-Idempotency-Key': idempotencyKey,
          },
          params: { payment_method: method, payment_channel: paymentChannel, payment_source: paymentSource }
        });
      }
      toast.success('Pembayaran berhasil dicatat!');
      setBillingPaymentBuktiFileMap((prev) => ({ ...prev, [billingId]: null }));
      setBillingPaymentNoteMap((prev) => ({ ...prev, [billingId]: '' }));
      setBillingPaymentSourceMap((prev) => ({ ...prev, [billingId]: (method === 'transfer' ? 'wa' : 'office') }));
      refreshBillingData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal mencatat pembayaran');
    } finally {
      setPayingBillingId('');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Apakah Anda yakin ingin menghapus tagihan ini?')) return;
    
    try {
      await axios.delete(`${API}/billings/${id}`, { headers: getAuthHeaders() });
      toast.success('Tagihan berhasil dihapus!');
      refreshBillingData();
    } catch (error) {
      toast.error('Gagal menghapus tagihan');
    }
  };

  const handleDownloadPDF = async (billingId) => {
    try {
      const response = await axios.get(`${API}/billings/${billingId}/invoice-pdf`, {
        headers: getAuthHeaders(),
        params: { print_mode: printMode },
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Tagihan_${billingId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('Tagihan berhasil didownload!');
    } catch (error) {
      toast.error('Gagal download tagihan');
    }
  };

  const handleDownloadReceipt = async (billingId) => {
    try {
      const response = await axios.get(`${API}/billings/${billingId}/receipt-pdf`, {
        headers: getAuthHeaders(),
        params: { print_mode: printMode },
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Kwitansi_${billingId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('Kwitansi berhasil didownload!');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal download kwitansi');
    }
  };

  const handleSendWhatsApp = async (billingId) => {
    try {
      const response = await axios.post(`${API}/billings/${billingId}/send-whatsapp`, null, {
        headers: getAuthHeaders()
      });
      window.open(response.data.whatsapp_url, '_blank');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal membuat link WhatsApp');
    }
  };

  const handleManualTertunggakReconcile = async () => {
    setReconcilingTertunggak(true);
    try {
      const response = await axios.post(`${API}/billings/reconcile-overdue`, {}, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Rekonsiliasi tunggakan selesai');
      refreshBillingData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal menjalankan rekonsiliasi tunggakan');
    } finally {
      setReconcilingTertunggak(false);
    }
  };

  const handleManualReactivateCleared = async () => {
    setReactivatingCleared(true);
    try {
      const response = await axios.post(`${API}/billings/reactivate-cleared`, {}, { headers: getAuthHeaders() });
      toast.success(response.data?.message || 'Reaktivasi pelanggan bersih selesai');
      refreshBillingData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal mengaktifkan kembali pelanggan yang tunggakannya sudah bersih');
    } finally {
      setReactivatingCleared(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(amount);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString('id-ID');
  };

  const getMonthName = (month) => {
    return months.find(m => m.value === month.toString())?.label || '';
  };

  const getBillingStateMeta = useCallback((stateValue) => {
    const state = String(stateValue || '').trim().toLowerCase();
    const map = {
      active: { label: 'active', tone: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-200' },
      unpaid: { label: 'unpaid', tone: 'border-amber-500/30 bg-amber-500/10 text-amber-200' },
      overjatuh_tempo: { label: 'tertunggak', tone: 'border-red-500/30 bg-red-500/10 text-red-200' },
      kandidat_suspend: { label: 'kandidat_suspend', tone: 'border-yellow-500/30 bg-yellow-500/10 text-yellow-200' },
      suspended: { label: 'suspended', tone: 'border-rose-500/30 bg-rose-500/10 text-rose-200' },
      restore_candidate: { label: 'restore_candidate', tone: 'border-cyan-500/30 bg-cyan-500/10 text-cyan-200' },
      draft: { label: 'draft', tone: 'border-slate-500/30 bg-slate-500/10 text-slate-200' },
    };
    return map[state] || { label: state || 'unknown', tone: 'border-slate-500/30 bg-slate-500/10 text-slate-200' };
  }, []);

  const getTagihanStatusMeta = useCallback((statusValue) => {
    const status = String(statusValue || '').trim().toLowerCase();
    const map = {
      draft: { label: 'draft', tone: 'border-slate-500/30 bg-slate-500/10 text-slate-200' },
      unpaid: { label: 'unpaid', tone: 'border-amber-500/30 bg-amber-500/10 text-amber-200' },
      overjatuh_tempo: { label: 'tertunggak', tone: 'border-red-500/30 bg-red-500/10 text-red-200' },
      paid: { label: 'paid', tone: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-200' },
      cancelled: { label: 'cancelled', tone: 'border-zinc-500/30 bg-zinc-500/10 text-zinc-300' },
    };
    return map[status] || { label: status || 'unknown', tone: 'border-slate-500/30 bg-slate-500/10 text-slate-200' };
  }, []);

  const getPaymentStatusMeta = useCallback((statusValue, approvalStatusValue) => {
    const approval = String(approvalStatusValue || '').trim().toLowerCase();
    const status = String(statusValue || '').trim().toLowerCase();
    if (approval === 'pending' || status === 'pending') {
      return { label: 'pending', tone: 'border-amber-500/30 bg-amber-500/10 text-amber-200' };
    }
    if (approval === 'approved' || status === 'paid') {
      return { label: 'approved', tone: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-200' };
    }
    if (approval === 'rejected' || status === 'rejected') {
      return { label: 'rejected', tone: 'border-red-500/30 bg-red-500/10 text-red-200' };
    }
    return { label: approval || status || 'unknown', tone: 'border-slate-500/30 bg-slate-500/10 text-slate-200' };
  }, []);

  const overdueCustomers = useMemo(() => {
    return Array.isArray(overdueControl?.overdue_customers) ? overdueControl.overdue_customers : [];
  }, [overdueControl]);

  const systemSource = String(systemMetrics?.genieacs_health?.last_source?.source || '-');
  const systemLatencyAvg = Number.isFinite(Number(systemMetrics?.genieacs_health?.avg_latency_ms))
    ? `${Number(systemMetrics.genieacs_health.avg_latency_ms)} ms`
    : '-';
  const systemLatencyP95 = Number.isFinite(Number(systemMetrics?.genieacs_health?.p95_latency_ms))
    ? `${Number(systemMetrics.genieacs_health.p95_latency_ms)} ms`
    : '-';
  const systemTransferSuccess = Number(systemMetrics?.transfer_approval?.success || 0);
  const systemTransferConflict = Number(systemMetrics?.transfer_approval?.conflict || 0);
  const systemTransferFail = Number(systemMetrics?.transfer_approval?.fail || 0);
  const systemTransferPending = Number(systemMetrics?.operational_counts?.transfer_pending || 0);
  const systemUnpaidTertunggak = Number(systemMetrics?.operational_counts?.billings_unpaid_overdue || 0);
  const systemRadiusQueueOpen = Number(systemMetrics?.operational_counts?.freeradius_queue_open || 0);

  const filteredTertunggakCustomers = useMemo(() => {
    const keyword = overdueSearchQuery.trim().toLowerCase();
    if (!keyword) return overdueCustomers;
    return overdueCustomers.filter((customer) => {
      const haystack = [
        customer.customer_id,
        customer.name,
        customer.phone,
        ...(Array.isArray(customer.invoice_numbers) ? customer.invoice_numbers : []),
      ].map((item) => String(item || '').toLowerCase()).join(' ');
      return haystack.includes(keyword);
    });
  }, [overdueCustomers, overdueSearchQuery]);

  const agingBucketCards = useMemo(() => {
    const source = overdueControl?.summary?.aging_buckets || {};
    return [
      { key: '1_7', fallbackLabel: '1-7 hari', border: 'border-yellow-500/20', bg: 'bg-yellow-500/10', text: 'text-yellow-200' },
      { key: '8_14', fallbackLabel: '8-14 hari', border: 'border-orange-500/20', bg: 'bg-orange-500/10', text: 'text-orange-200' },
      { key: '15_30', fallbackLabel: '15-30 hari', border: 'border-red-500/20', bg: 'bg-red-500/10', text: 'text-red-200' },
      { key: '31_plus', fallbackLabel: '>30 hari', border: 'border-fuchsia-500/20', bg: 'bg-fuchsia-500/10', text: 'text-fuchsia-200' },
    ].map((config) => ({
      ...config,
      ...(source[config.key] || {}),
    }));
  }, [overdueControl]);
  const pendingTransferByBillingId = useMemo(() => {
    const map = {};
    (transferSubmissions || []).forEach((item) => {
      const key = String(item?.billing_id || '');
      if (!key) return;
      map[key] = item;
    });
    return map;
  }, [transferSubmissions]);
  const pendingVerificationCount = useMemo(
    () => Object.keys(pendingTransferByBillingId || {}).length,
    [pendingTransferByBillingId]
  );
  const pendingVerificationAmount = useMemo(
    () => (transferSubmissions || []).reduce((sum, item) => sum + Number(item?.amount || 0), 0),
    [transferSubmissions]
  );
  const paymentPendingCount = useMemo(
    () => Number((payments || []).filter((item) => String(item?.status || '').toLowerCase() === 'pending' || String(item?.approval_status || '').toLowerCase() === 'pending').length || 0),
    [payments]
  );
  const pendingPersetujuanCount = paymentPendingCount > 0 ? paymentPendingCount : pendingVerificationCount;
  const normalizeBillingState = useCallback((customer) => {
    return String(
      customer?.billing_state
      || customer?.billingState
      || customer?.billing_snapshot?.billing_state
      || customer?.status
      || 'active'
    ).trim().toLowerCase() || 'active';
  }, []);
  const customerById = useMemo(() => {
    const map = {};
    (customers || []).forEach((customer) => {
      const key = String(customer?.id || '').trim();
      if (key) map[key] = customer;
    });
    return map;
  }, [customers]);
  const customerBillingRows = useMemo(() => {
    return (customers || []).map((customer) => {
      const customerId = String(customer?.id || '').trim();
      const customerTagihans = (billings || []).filter((item) => String(item?.customer_id || '').trim() === customerId);
      const latestTagihan = customerTagihans.length ? customerTagihans[0] : null;
      const state = normalizeBillingState(customer);
      const dueDate = customer?.billing_due_date || customer?.dueDate || customer?.due_date || latestTagihan?.due_date || null;
      const overdueDays = Number(
        customer?.billing_overdue_days
        ?? customer?.overdueDays
        ?? customer?.overdue_days
        ?? latestTagihan?.overdue_days
        ?? 0
      ) || 0;
      const suspendEligible = Boolean(
        customer?.billing_suspend_eligible
        ?? customer?.suspendEligible
        ?? customer?.suspend_eligible
        ?? false
      );
      return {
        customer,
        customer_id: customerId,
        state,
        due_date: dueDate,
        overdue_days: overdueDays,
        suspend_eligible: suspendEligible,
        package_name: String(customer?.package_name || '-'),
        last_invoice_id: String(customer?.billing_last_invoice_id || latestTagihan?.id || '').trim(),
        last_invoice_number: String(latestTagihan?.invoice_number || '').trim(),
        last_payment_at: customer?.billing_last_payment_at || customer?.last_payment_at || null,
      };
    });
  }, [billings, customers, normalizeBillingState]);
  const transferPendingPaymentRows = useMemo(() => {
    return (transferSubmissions || []).map((item) => ({
      id: `transfer-${item?.id}`,
      tagihan_id: String(item?.billing_id || '').trim() || null,
      billing_id: String(item?.billing_id || '').trim() || null,
      tagihan_number: String(item?.invoice_number || '').trim() || '-',
      customer_id: String(item?.customer_id || '').trim() || null,
      customer_name: String(item?.customer_name || '').trim() || '-',
      amount: Number(item?.amount || 0),
      method: 'transfer',
      status: 'pending',
      approval_status: 'pending',
      submitted_at: item?.created_at || null,
      approved_at: null,
      approved_by: null,
      proof_url: item?.proof_file_url || null,
      source: 'transfer_submission',
      source_id: String(item?.id || '').trim(),
    }));
  }, [transferSubmissions]);
  const paymentRows = useMemo(() => {
    const existing = (payments || []).map((item) => {
      const customerId = String(item?.customer_id || '').trim();
      const customer = customerById[customerId];
      const tagihan = (billings || []).find((billing) => String(billing?.id || '').trim() === String(item?.billing_id || item?.invoice_id || '').trim());
      return {
        ...item,
        tagihan_id: item?.invoice_id || item?.billing_id || null,
        tagihan_number: item?.invoice_number || tagihan?.invoice_number || '-',
        customer_name: customer?.name || tagihan?.customer_name || '-',
        approval_status: item?.approval_status || (String(item?.status || '').toLowerCase() === 'paid' ? 'approved' : item?.status) || null,
        source: 'payment_record',
      };
    });
    return [...transferPendingPaymentRows, ...existing];
  }, [billings, customerById, payments, transferPendingPaymentRows]);
  const paymentByTagihanId = useMemo(() => {
    const map = {};
    paymentRows.forEach((item) => {
      const tagihanId = String(item?.invoice_id || item?.billing_id || '').trim();
      if (!invoiceId) return;
      map[invoiceId] = item;
    });
    return map;
  }, [paymentRows]);
  const pendingPersetujuanRows = useMemo(
    () => paymentRows.filter((item) => {
      const meta = getPaymentStatusMeta(item?.status, item?.approval_status);
      return meta.label === 'pending';
    }),
    [paymentRows, getPaymentStatusMeta]
  );
  const billingEventRows = useMemo(() => {
    return (billingEvents || [])
      .slice()
      .sort((a, b) => new Date(b?.event_at || b?.created_at || 0).getTime() - new Date(a?.event_at || a?.created_at || 0).getTime());
  }, [billingEvents]);
  const unpaidCustomerCount = useMemo(
    () => customerBillingRows.filter((item) => item.state === 'unpaid').length,
    [customerBillingRows]
  );
  const overdueCustomerCount = useMemo(
    () => customerBillingRows.filter((item) => item.state === 'overdue').length,
    [customerBillingRows]
  );
  const suspendCandidateCount = useMemo(
    () => customerBillingRows.filter((item) => item.state === 'kandidat_suspend' || item.suspend_eligible).length,
    [customerBillingRows]
  );
  const restoreCandidateCount = useMemo(
    () => customerBillingRows.filter((item) => item.state === 'restore_candidate').length,
    [customerBillingRows]
  );
  const overdueRows = useMemo(
    () => customerBillingRows
      .filter((item) => item.state === 'overdue')
      .sort((a, b) => Number(b.overdue_days || 0) - Number(a.overdue_days || 0)),
    [customerBillingRows]
  );
  const suspendCandidateRows = useMemo(
    () => customerBillingRows
      .filter((item) => item.state === 'kandidat_suspend' || item.suspend_eligible)
      .sort((a, b) => Number(b.overdue_days || 0) - Number(a.overdue_days || 0)),
    [customerBillingRows]
  );
  const restoreCandidateRows = useMemo(
    () => customerBillingRows
      .filter((item) => item.state === 'restore_candidate')
      .sort((a, b) => new Date(b.last_payment_at || 0).getTime() - new Date(a.last_payment_at || 0).getTime()),
    [customerBillingRows]
  );
  const customerEventInsightById = useMemo(() => {
    const map = {};
    const now = Date.now();
    const horizonMs = 90 * 24 * 60 * 60 * 1000;
    (billingEventRows || []).forEach((event) => {
      const customerId = String(event?.customer_id || '').trim();
      if (!customerId) return;
      const eventAt = new Date(event?.event_at || event?.created_at || 0).getTime();
      if (!Number.isFinite(eventAt) || now - eventAt > horizonMs) return;
      const entry = map[customerId] || {
        overdueTriggered: 0,
        suspendCandidate: 0,
        restoreMarked: 0,
        paymentTolaked: 0,
      };
      const type = String(event?.event_type || '').trim().toLowerCase();
      if (type === 'overdue_triggered') entry.overdueTriggered += 1;
      if (type === 'kandidat_suspend_marked') entry.suspendCandidate += 1;
      if (type === 'restore_candidate_marked' || type === 'restore_executed') entry.restoreMarked += 1;
      if (type === 'payment_rejected') entry.paymentTolaked += 1;
      map[customerId] = entry;
    });
    return map;
  }, [billingEventRows]);
  const eligibleSuspendSet = useMemo(() => {
    const set = new Set();
    (overdueControl?.eligible_suspend_customers || []).forEach((item) => {
      [item?.id, item?.customer_id, item?.customer_code, item?.name].forEach((candidate) => {
        const key = normalizeKey(candidate);
        if (key) set.add(key);
      });
    });
    return set;
  }, [overdueControl]);
  const reactivationReadySet = useMemo(() => {
    const set = new Set();
    (overdueControl?.reactivation_candidates || []).forEach((item) => {
      [item?.id, item?.customer_id, item?.customer_code, item?.name].forEach((candidate) => {
        const key = normalizeKey(candidate);
        if (key) set.add(key);
      });
    });
    return set;
  }, [overdueControl]);
  const autoSuspendedSet = useMemo(() => {
    const set = new Set();
    (overdueCustomers || []).forEach((item) => {
      if (!item?.auto_suspended_by_billing) return;
      [item?.id, item?.customer_id, item?.customer_code, item?.name].forEach((candidate) => {
        const key = normalizeKey(candidate);
        if (key) set.add(key);
      });
    });
    return set;
  }, [overdueCustomers]);
  const openTagihanCount = useMemo(
    () => (billings || []).filter((item) => ['unpaid', 'overdue'].includes(String(item?.status || '').toLowerCase())).length,
    [billings]
  );
  const monthlyRevenue = Number(stats.paid_amount || incomeFull.income_postpaid || 0);

  const resolveBillingEngineState = useCallback((billing) => {
    const customerId = String(billing?.customer_id || '').trim();
    const customer = customerById[customerId];
    const snapshotState = normalizeBillingState(customer);
    if (snapshotState === 'suspended') {
      return { key: 'suspended', label: 'suspended', tone: 'border-red-500/40 bg-red-500/15 text-red-200' };
    }
    if (snapshotState === 'kandidat_suspend') {
      return { key: 'kandidat_suspend', label: 'kandidat_suspend', tone: 'border-yellow-500/40 bg-yellow-500/15 text-yellow-200' };
    }
    if (snapshotState === 'restore_candidate') {
      return { key: 'restore_candidate', label: 'restore_candidate', tone: 'border-green-500/40 bg-green-500/15 text-green-200' };
    }
    const status = String(billing?.status || '').toLowerCase();
    if (status === 'paid') return { key: 'paid', label: 'paid', tone: 'border-emerald-500/40 bg-emerald-500/15 text-emerald-200' };
    if (status === 'overdue') return { key: 'overdue', label: 'tertunggak', tone: 'border-red-500/40 bg-red-500/15 text-red-200' };
    if (status === 'unpaid') return { key: 'unpaid', label: 'unpaid', tone: 'border-amber-500/40 bg-amber-500/15 text-amber-200' };
    return { key: 'draft', label: 'draft', tone: 'border-slate-500/40 bg-slate-500/15 text-slate-200' };
  }, [customerById, normalizeBillingState]);

  const showCustomerWorkspace = billingWorkspaceTab === 'pelanggan';
  const showTagihanWorkspace = billingWorkspaceTab === 'invoice';
  const showPaymentWorkspace = billingWorkspaceTab === 'pembayaran';
  const showSuspendWorkspace = billingWorkspaceTab === 'suspend';
  const showPersetujuanWorkspace = billingWorkspaceTab === 'approval';
  const showEventsWorkspace = billingWorkspaceTab === 'events';

  const isPeriodView = billingView === 'period';
  const isVerificationView = billingView === 'verification';
  const periodReady = !isPeriodView || (Boolean(filterMonth) && Boolean(filterYear));
  const displayedBillings = useMemo(() => {
    let rows = billings;
    if (filterStatus) {
      rows = rows.filter((item) => String(item?.status || '').toLowerCase() === String(filterStatus).toLowerCase());
    }
    if (isPeriodView) {
      rows = rows.filter((item) => String(item.period_month || '') === String(filterMonth || '') && String(item.period_year || '') === String(filterYear || ''));
    }
    if (isVerificationView) {
      rows = rows.filter((item) => String(item.status || '').toLowerCase() !== 'paid' && Boolean(pendingTransferByBillingId[String(item.id || '')]));
    }
    if (filterBukti === 'with') {
      rows = rows.filter((item) => Boolean(String(item.payment_proof_url || '').trim()));
    } else if (filterBukti === 'without') {
      rows = rows.filter((item) => !String(item.payment_proof_url || '').trim());
    }
    if (filterPaymentMethod !== 'all') {
      rows = rows.filter((item) => {
        const method = String(item.payment_method || '').toLowerCase();
        const channel = String(item.payment_channel || '').toLowerCase();
        if (filterPaymentMethod === 'cash') return method === 'cash' || channel.includes('cash');
        if (filterPaymentMethod === 'transfer') return method === 'transfer' || channel.includes('transfer');
        if (filterPaymentMethod === 'gateway') return channel.includes('gateway') || channel.includes('va_');
        return true;
      });
    }
    const keyword = String(billingSearchQuery || '').trim().toLowerCase();
    if (keyword) {
      rows = rows.filter((item) => {
        const haystack = [
          item.invoice_number,
          item.customer_name,
          item.customer_id,
        ].map((v) => String(v || '').toLowerCase()).join(' ');
        return haystack.includes(keyword);
      });
    }
    if (invoiceFocus === 'operational') {
      rows = rows.filter((item) => {
        const status = String(item?.status || '').toLowerCase();
        return status === 'unpaid' || status === 'overdue' || Boolean(pendingTransferByBillingId[String(item?.id || '')]);
      });
    } else if (invoiceFocus === 'paid_only') {
      rows = rows.filter((item) => String(item?.status || '').toLowerCase() === 'paid');
    }
    rows = rows.slice().sort((a, b) => {
      const rank = (item) => {
        const status = String(item?.status || '').toLowerCase();
        if (status === 'overdue') return 3;
        if (status === 'unpaid') return 2;
        if (Boolean(pendingTransferByBillingId[String(item?.id || '')])) return 1;
        return 0;
      };
      const diffRank = rank(b) - rank(a);
      if (diffRank !== 0) return diffRank;
      const dueA = new Date(a?.due_date || 0).getTime();
      const dueB = new Date(b?.due_date || 0).getTime();
      return dueA - dueB;
    });
    return rows;
  }, [billings, filterStatus, filterMonth, filterYear, isPeriodView, isVerificationView, filterBukti, filterPaymentMethod, billingSearchQuery, invoiceFocus, pendingTransferByBillingId]);
  const totalDisplayedBillings = displayedBillings.length;
  const totalBillingPages = Math.max(1, Math.ceil(totalDisplayedBillings / billingPerPage));
  const pagedBillings = useMemo(() => {
    const start = (billingPage - 1) * billingPerPage;
    return displayedBillings.slice(start, start + billingPerPage);
  }, [displayedBillings, billingPage, billingPerPage]);
  useEffect(() => {
    setBillingPage(1);
  }, [filterStatus, filterMonth, filterYear, filterBukti, filterPaymentMethod, billingSearchQuery, billingView, invoiceFocus, billingPerPage]);
  useEffect(() => {
    if (billingPage > totalBillingPages) {
      setBillingPage(totalBillingPages);
    }
  }, [billingPage, totalBillingPages]);

  const filteredTransferSubmissions = useMemo(() => {
    const keyword = String(transferSubmissionSearch || '').trim().toLowerCase();
    if (!keyword) return transferSubmissions;
    return transferSubmissions.filter((item) => {
      const haystack = [
        item.invoice_number,
        item.customer_name,
        item.customer_id,
        item.bank_account_name,
        item.bank_account_number,
        item.note,
      ].map((v) => String(v || '').toLowerCase()).join(' ');
      return haystack.includes(keyword);
    });
  }, [transferSubmissions, transferSubmissionSearch]);

  const selectedVisibleTransferCount = useMemo(
    () => filteredTransferSubmissions.filter((item) => selectedTransferSubmissionIds.includes(String(item.id))).length,
    [filteredTransferSubmissions, selectedTransferSubmissionIds]
  );
  const allVisibleTransfersSelected = useMemo(
    () => filteredTransferSubmissions.length > 0 && filteredTransferSubmissions.every((item) => selectedTransferSubmissionIds.includes(String(item.id))),
    [filteredTransferSubmissions, selectedTransferSubmissionIds]
  );
  const pendingBillingsForGateway = useMemo(
    () => (billings || []).filter((item) => String(item.status || '').toLowerCase() !== 'paid'),
    [billings],
  );
  useEffect(() => {
    if (!pendingBillingsForGateway.length) {
      setGatewayBillingId('');
      return;
    }
    if (!gatewayBillingId || !pendingBillingsForGateway.some((item) => item.id === gatewayBillingId)) {
      setGatewayBillingId(pendingBillingsForGateway[0].id);
    }
  }, [pendingBillingsForGateway, gatewayBillingId]);
  const handleExportTertunggakCsv = () => {
    if (filteredTertunggakCustomers.length === 0) {
      toast.error('Tidak ada data tunggakan untuk diekspor');
      return;
    }

    const escapeCsv = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`;
    const rows = [
      ['Customer ID', 'Nama', 'Telepon', 'Status Pelanggan', 'Tertunggak Hari', 'Bucket Aging', 'Jumlah Tagihan', 'Total Tunggakan', 'Tagihan', 'Eligible Suspend', 'Auto Suspended Billing', 'Waktu Suspend'],
      ...filteredTertunggakCustomers.map((customer) => ([
        customer.customer_id || '',
        customer.name || '',
        customer.phone || '',
        customer.status || '',
        customer.oldest_overdue_days || 0,
        customer.aging_bucket || '',
        customer.overdue_count || 0,
        customer.total_overdue_amount || 0,
        Array.isArray(customer.invoice_numbers) ? customer.invoice_numbers.join(', ') : '',
        customer.eligible_suspend ? 'Ya' : 'Tidak',
        customer.auto_suspended_by_billing ? 'Ya' : 'Tidak',
        customer.billing_auto_suspended_at || '',
      ])),
    ];

    const csvContent = rows.map((row) => row.map(escapeCsv).join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `billing-overdue-${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    toast.success('Ekspor data tunggakan berhasil dibuat');
  };

  return (
    <>
      {loading && (
        <StaffPageLoadingOverlay text="Memuat data tagihan..." />
      )}
      


      {/* Main Content */}
      <AppShell>
      <PageContainer>
        {/* Header */}
        <div className="w-full">
        <StaffPageHeader
          className="mb-8"
          eyebrow="Billing"
          title="Billing & Pembayaran"
          subtitle="Kelola tagihan bulanan pelanggan dengan alur pembayaran yang rapi."
          titleClassName="text-white"
          subtitleClassName="text-cyan-100/90"
          actions={(
            <>
              <Button onClick={() => setIsGenerateModalOpen(true)} variant="outline" className="btn-secondary">
                <Calendar className="w-4 h-4 mr-2" />Generate Bulanan
              </Button>
              <Button onClick={() => setIsModalOpen(true)} className="btn-primary text-white">
                <Plus className="w-4 h-4 mr-2" />Buat Tagihan
              </Button>
            </>
          )}
        />

        {/* Layer A - Billing Overview */}
        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-4 mb-6">
          <div className="bg-[#121212] rounded-xl p-4 border border-amber-500/20">
            <p className="text-gray-400 text-xs">Pelanggan Belum Bayar</p>
            <p className="text-2xl font-bold text-amber-300 mt-1">{unpaidCustomerCount}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-red-500/20">
            <p className="text-gray-400 text-xs">Pelanggan Tertunggak</p>
            <p className="text-2xl font-bold text-red-300 mt-1">{overdueCustomerCount}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-yellow-500/20">
            <p className="text-gray-400 text-xs">Kandidat Suspend</p>
            <p className="text-2xl font-bold text-yellow-300 mt-1">{suspendCandidateCount}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-teal-500/20">
            <p className="text-gray-400 text-xs">Kandidat Pemulihan</p>
            <p className="text-2xl font-bold text-teal-300 mt-1">{restoreCandidateCount}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-cyan-500/20">
            <p className="text-gray-400 text-xs">Menunggu Persetujuan</p>
            <p className="text-2xl font-bold text-cyan-300 mt-1">{pendingPersetujuanCount}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-indigo-500/20">
            <p className="text-gray-400 text-xs">Tagihan Terbuka</p>
            <p className="text-2xl font-bold text-indigo-300 mt-1">{openTagihanCount}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-emerald-500/20">
            <p className="text-gray-400 text-xs">Pendapatan Bulan Ini</p>
            <p className="text-2xl font-bold text-emerald-300 mt-1">{formatCurrency(monthlyRevenue)}</p>
          </div>
        </div>
        {pendingPersetujuanCount > 0 && (
          <div className="mb-4 rounded-xl border border-amber-400/30 bg-amber-500/10 px-4 py-3 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
            <div>
              <p className="text-amber-200 text-sm font-semibold">Persetujuan pembayaran menunggu tindakan</p>
              <p className="text-amber-100/80 text-xs">
                {pendingPersetujuanCount} pembayaran menunggu persetujuan. Prioritaskan verifikasi untuk mencegah keterlambatan pemulihan layanan.
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button size="sm" className="bg-amber-600 hover:bg-amber-700 text-white" onClick={() => { setBillingWorkspaceTab('approval'); setBillingView('verification'); }}>
                Tinjau Persetujuan
              </Button>
              <Button size="sm" variant="outline" className="btn-secondary" onClick={() => setBillingWorkspaceTab('pembayaran')}>
                Buka Catatan Pembayaran
              </Button>
            </div>
          </div>
        )}

        {/* Layer B - Pusat Aksi Tagihan */}
        <div className="bg-[#121212] rounded-xl p-5 border border-white/10 mb-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 mb-4">
            <div>
              <h2 className="font-outfit text-lg font-semibold text-white">Pusat Aksi Tagihan</h2>
              <p className="text-xs text-gray-400">Fokus ke aksi hari ini: tertunggak, kandidat suspend, persetujuan pembayaran, dan pemulihan.</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button size="sm" variant="outline" className="btn-secondary" onClick={handleManualTertunggakReconcile} disabled={reconcilingTertunggak}>
                {reconcilingTertunggak ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <RotateCcw className="w-3 h-3 mr-1" />}
                Rekonsiliasi Tertunggak
              </Button>
              <Button size="sm" className="bg-green-600 hover:bg-green-700 text-white" onClick={handleManualReactivateCleared} disabled={reactivatingCleared}>
                {reactivatingCleared ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <Check className="w-3 h-3 mr-1" />}
                Kandidat Pemulihan
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
            <div className="rounded-lg border border-red-500/20 bg-red-500/10 p-3">
              <p className="text-xs text-red-200">Tertunggak</p>
              <p className="text-sm text-white mt-1">{overdueCustomerCount} pelanggan tertunggak</p>
              <Button size="sm" variant="outline" className="mt-2 btn-secondary h-8 text-xs" onClick={() => { setBillingWorkspaceTab('pelanggan'); setFilterStatus('overdue'); }}>
                Tinjau Tertunggak
              </Button>
            </div>
            <div className="rounded-lg border border-yellow-500/20 bg-yellow-500/10 p-3">
              <p className="text-xs text-yellow-200">Kandidat Suspend</p>
              <p className="text-sm text-white mt-1">{suspendCandidateCount} pelanggan siap suspend</p>
              <Button size="sm" variant="outline" className="mt-2 btn-secondary h-8 text-xs" onClick={() => setBillingWorkspaceTab('suspend')}>
                Tinjau Suspend
              </Button>
            </div>
            <div className="rounded-lg border border-cyan-500/20 bg-cyan-500/10 p-3">
              <p className="text-xs text-cyan-200">Menunggu Persetujuan</p>
              <p className="text-sm text-white mt-1">{pendingPersetujuanCount} pembayaran menunggu persetujuan</p>
              <Button size="sm" variant="outline" className="mt-2 btn-secondary h-8 text-xs" onClick={() => { setBillingWorkspaceTab('approval'); setBillingView('verification'); }}>
                Setujui Sekarang
              </Button>
            </div>
            <div className="rounded-lg border border-emerald-500/20 bg-emerald-500/10 p-3">
              <p className="text-xs text-emerald-200">Kandidat Pemulihan</p>
              <p className="text-sm text-white mt-1">{restoreCandidateCount} pelanggan siap dipulihkan</p>
              <Button size="sm" variant="outline" className="mt-2 btn-secondary h-8 text-xs" onClick={() => setBillingWorkspaceTab('suspend')}>
                Buka Alur Pemulihan
              </Button>
            </div>
          </div>

          <div className="grid xl:grid-cols-4 gap-3 mt-4">
            <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
              <div className="flex items-center justify-between gap-2 mb-2">
                <p className="text-xs text-red-200 font-medium">Tertunggak</p>
                <span className="text-[11px] text-red-300">{overdueRows.length}</span>
              </div>
              {overdueRows.length === 0 ? (
                <p className="text-xs text-gray-500">Tidak ada pelanggan tertunggak.</p>
              ) : (
                <div className="space-y-2 max-h-52 overflow-y-auto pr-1">
                  {overdueRows.slice(0, 6).map((row) => {
                    const stateMeta = getBillingStateMeta(row.state);
                    const insight = customerEventInsightById[row.customer_id] || {};
                    return (
                      <div key={`ov-${row.customer_id}`} className="rounded-md border border-white/10 px-2 py-2">
                        <p className="text-xs text-white">{row.customer?.name || '-'} <span className="text-gray-500">({row.customer?.customer_id || '-'})</span></p>
                        <p className="text-[11px] text-gray-500 mt-1">
                          jatuh_tempo: {row.due_date ? formatDate(row.due_date) : '-'} / tertunggak: {Number(row.overdue_days || 0)} hari
                        </p>
                        <div className="mt-1 flex items-center gap-1.5 flex-wrap">
                          <span className={`px-2 py-0.5 rounded-full text-[10px] border ${stateMeta.tone}`}>{stateMeta.label}</span>
                          {insight.overdueTriggered >= 3 ? (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-red-500/30 bg-red-500/10 text-red-200">Tertunggak {insight.overdueTriggered}x/90h</span>
                          ) : null}
                        </div>
                        <div className="mt-2 flex gap-1.5">
                          <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => { setBillingWorkspaceTab('suspend'); setTertunggakSearchQuery(row.customer?.name || row.customer?.customer_id || ''); }}>Tinjau Suspend</Button>
                          <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => navigate(`/dadu/pelanggan?search=${encodeURIComponent(row.customer?.customer_id || row.customer?.name || '')}`)}>Buka Pelanggan</Button>
                          {row.last_invoice_id ? (
                            <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => { setBillingWorkspaceTab('invoice'); setBillingSearchQuery(row.last_invoice_number || row.last_invoice_id); }}>Buka Tagihan</Button>
                          ) : null}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
              <div className="flex items-center justify-between gap-2 mb-2">
                <p className="text-xs text-yellow-200 font-medium">Kandidat Suspend</p>
                <span className="text-[11px] text-yellow-300">{suspendCandidateRows.length}</span>
              </div>
              {suspendCandidateRows.length === 0 ? (
                <p className="text-xs text-gray-500">Belum ada kandidat suspend.</p>
              ) : (
                <div className="space-y-2 max-h-52 overflow-y-auto pr-1">
                  {suspendCandidateRows.slice(0, 6).map((row) => {
                    const insight = customerEventInsightById[row.customer_id] || {};
                    return (
                      <div key={`sc-${row.customer_id}`} className="rounded-md border border-white/10 px-2 py-2">
                        <p className="text-xs text-white">{row.customer?.name || '-'} <span className="text-gray-500">({row.customer?.customer_id || '-'})</span></p>
                        <p className="text-[11px] text-gray-500 mt-1">
                          jatuh_tempo: {row.due_date ? formatDate(row.due_date) : '-'} / tertunggak: {Number(row.overdue_days || 0)} hari
                        </p>
                        <div className="mt-1 flex flex-wrap items-center gap-1.5">
                          <span className="px-2 py-0.5 rounded-full text-[10px] border border-yellow-500/30 bg-yellow-500/10 text-yellow-200">kandidat_suspend</span>
                          {row.suspend_eligible ? (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-amber-500/30 bg-amber-500/10 text-amber-200">layak=true</span>
                          ) : null}
                          {insight.suspendCandidate >= 2 ? (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-fuchsia-500/30 bg-fuchsia-500/10 text-fuchsia-200">riwayat suspend berulang</span>
                          ) : null}
                        </div>
                        <div className="mt-2 flex gap-1.5">
                          <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => { setBillingWorkspaceTab('suspend'); setTertunggakSearchQuery(row.customer?.name || row.customer?.customer_id || ''); }}>Tinjau Suspend</Button>
                          <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => navigate(`/dadu/pelanggan?search=${encodeURIComponent(row.customer?.customer_id || row.customer?.name || '')}`)}>Buka Pelanggan</Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
              <div className="flex items-center justify-between gap-2 mb-2">
                <p className="text-xs text-cyan-200 font-medium">Persetujuan Pembayaran</p>
                <span className="text-[11px] text-cyan-300">{pendingPersetujuanRows.length}</span>
              </div>
              {pendingPersetujuanRows.length === 0 ? (
                <p className="text-xs text-gray-500">Tidak ada pembayaran menunggu persetujuan.</p>
              ) : (
                <div className="space-y-2 max-h-52 overflow-y-auto pr-1">
                  {pendingPersetujuanRows.slice(0, 6).map((item) => (
                    <div key={`pa-${item.id}`} className="rounded-md border border-white/10 px-2 py-2">
                      <p className="text-xs text-white">{item.customer_name || '-'} <span className="text-gray-500">/ {item.invoice_number || '-'}</span></p>
                      <p className="text-[11px] text-gray-500 mt-1">
                        {formatCurrency(item.amount || 0)} / {String(item.method || '-').toUpperCase()} / {item.submitted_at ? formatDateTime(item.submitted_at) : '-'}
                      </p>
                      <div className="mt-2 flex gap-1.5">
                        <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => { setBillingWorkspaceTab('approval'); setBillingView('verification'); }}>Setujui</Button>
                        <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => { setBillingWorkspaceTab('approval'); setBillingView('verification'); }}>Tolak</Button>
                        <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => { setBillingWorkspaceTab('invoice'); setBillingSearchQuery(item.invoice_number || String(item.invoice_id || '')); }}>Buka Tagihan</Button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
              <div className="flex items-center justify-between gap-2 mb-2">
                <p className="text-xs text-emerald-200 font-medium">Kandidat Pemulihan</p>
                <span className="text-[11px] text-emerald-300">{restoreCandidateRows.length}</span>
              </div>
              {restoreCandidateRows.length === 0 ? (
                <p className="text-xs text-gray-500">Tidak ada kandidat pemulihan.</p>
              ) : (
                <div className="space-y-2 max-h-52 overflow-y-auto pr-1">
                  {restoreCandidateRows.slice(0, 6).map((row) => {
                    const insight = customerEventInsightById[row.customer_id] || {};
                    return (
                      <div key={`rs-${row.customer_id}`} className="rounded-md border border-white/10 px-2 py-2">
                        <p className="text-xs text-white">{row.customer?.name || '-'} <span className="text-gray-500">({row.customer?.customer_id || '-'})</span></p>
                        <p className="text-[11px] text-gray-500 mt-1">
                          pembayaran_terakhir: {row.last_payment_at ? formatDateTime(row.last_payment_at) : '-'} / tagihan: {row.last_invoice_number || row.last_invoice_id || '-'}
                        </p>
                        <div className="mt-1 flex flex-wrap items-center gap-1.5">
                          {insight.restoreMarked > 0 ? (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-emerald-500/30 bg-emerald-500/10 text-emerald-200">Baru dipulihkan</span>
                          ) : null}
                        </div>
                        <div className="mt-2 flex gap-1.5">
                          <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => { setBillingWorkspaceTab('suspend'); setTertunggakSearchQuery(row.customer?.name || row.customer?.customer_id || ''); }}>Pulihkan Layanan</Button>
                          <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => navigate(`/dadu/pelanggan?search=${encodeURIComponent(row.customer?.customer_id || row.customer?.name || '')}`)}>Buka Pelanggan</Button>
                          <Button size="sm" variant="outline" className="btn-secondary h-7 text-[10px]" onClick={() => setBillingWorkspaceTab('events')}>Lihat Kejadian</Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Layer C - Billing Workspace */}
        <div className="grid sm:grid-cols-3 lg:grid-cols-6 gap-2 mb-6">
          <button type="button" onClick={() => setBillingWorkspaceTab('pelanggan')} className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${showCustomerWorkspace ? 'bg-brand-blue/10 text-brand-blue border-brand-blue/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}>Pelanggan</button>
          <button type="button" onClick={() => setBillingWorkspaceTab('invoice')} className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${showTagihanWorkspace ? 'bg-brand-blue/10 text-brand-blue border-brand-blue/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}>Tagihan</button>
          <button type="button" onClick={() => setBillingWorkspaceTab('pembayaran')} className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${showPaymentWorkspace ? 'bg-brand-blue/10 text-brand-blue border-brand-blue/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}>Pembayaran</button>
          <button type="button" onClick={() => setBillingWorkspaceTab('suspend')} className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${showSuspendWorkspace ? 'bg-brand-blue/10 text-brand-blue border-brand-blue/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}>Suspend</button>
          <button type="button" onClick={() => setBillingWorkspaceTab('approval')} className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${showPersetujuanWorkspace ? 'bg-brand-blue/10 text-brand-blue border-brand-blue/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}>Persetujuan</button>
          <button type="button" onClick={() => setBillingWorkspaceTab('events')} className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${showEventsWorkspace ? 'bg-brand-blue/10 text-brand-blue border-brand-blue/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}>Aktivitas / Kejadian</button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-[#121212] rounded-xl p-4 border border-white/10">
            <div className="flex items-center gap-2 mb-2">
              <FileText className="w-4 h-4 text-gray-400" />
              <span className="text-gray-400 text-sm">Total Tagihan</span>
            </div>
            <p className="text-2xl font-bold text-white">{stats.total_invoices || 0}</p>
            <p className="text-cyan-200 text-sm font-extrabold font-mono tracking-tight">{formatCurrency(stats.total_amount || 0)}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-green-500/20">
            <div className="flex items-center gap-2 mb-2">
              <Check className="w-4 h-4 text-green-400" />
              <span className="text-gray-400 text-sm">Lunas</span>
            </div>
            <p className="text-2xl font-bold text-green-400">{stats.paid || 0}</p>
            <p className="text-green-300 text-sm font-extrabold font-mono tracking-tight">{formatCurrency(stats.paid_amount || 0)}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-yellow-500/20">
            <div className="flex items-center gap-2 mb-2">
              <Clock className="w-4 h-4 text-yellow-400" />
              <span className="text-gray-400 text-sm">Belum Bayar</span>
            </div>
            <p className="text-2xl font-bold text-yellow-400">{stats.unpaid || 0}</p>
            <p className="text-amber-300 text-sm font-extrabold font-mono tracking-tight">{formatCurrency(stats.unpaid_amount || 0)}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-red-500/20">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle className="w-4 h-4 text-red-400" />
              <span className="text-gray-400 text-sm">Jatuh Tempo</span>
            </div>
            <p className="text-2xl font-bold text-red-400">{stats.overdue || 0}</p>
            <p className="text-rose-300 text-sm font-extrabold font-mono tracking-tight">{formatCurrency(overdueControl.summary?.overdue_amount_total || 0)}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-[#121212] rounded-xl p-4 border border-emerald-500/20">
            <p className="text-gray-400 text-sm">Income Prepaid</p>
            <p className="text-xl font-bold text-emerald-300 mt-1">{loadingIncomeFull ? '...' : formatCurrency(incomeFull.income_prepaid || 0)}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-cyan-500/20">
            <p className="text-gray-400 text-sm">Income Postpaid</p>
            <p className="text-xl font-bold text-cyan-300 mt-1">{loadingIncomeFull ? '...' : formatCurrency(incomeFull.income_postpaid || 0)}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-violet-500/20">
            <p className="text-gray-400 text-sm">Income Voucher</p>
            <p className="text-xl font-bold text-violet-300 mt-1">{loadingIncomeFull ? '...' : formatCurrency(incomeFull.income_voucher || 0)}</p>
          </div>
          <div className="bg-[#121212] rounded-xl p-4 border border-green-500/20">
            <p className="text-gray-400 text-sm">Net Income</p>
            <p className="text-xl font-bold text-green-300 mt-1">{loadingIncomeFull ? '...' : formatCurrency(incomeFull.net_income || 0)}</p>
            <p className="text-xs text-gray-500 mt-1">Komisi agen: {formatCurrency(incomeFull.agent_commission || 0)}</p>
          </div>
        </div>

        {showPaymentWorkspace && (
        <>
        <div className="bg-[#121212] rounded-xl p-6 border border-white/10 mb-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 mb-4">
            <div>
              <h2 className="font-outfit text-xl font-semibold text-white">Pembayaran Virtual Account</h2>
              <p className="text-gray-400 text-sm">Buat transaksi payment gateway, lalu sistem otomatis approve dan perpanjang masa aktif +1 bulan saat pembayaran sukses.</p>
            </div>
            <Button onClick={fetchGatewayTransactions} disabled={loadingGatewayTransactions} variant="outline" className="btn-secondary">
              {loadingGatewayTransactions ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
              Muat Ulang Gateway
            </Button>
          </div>

          <div className="grid md:grid-cols-4 gap-3 mb-4">
            <div className="md:col-span-2">
              <label className="staff-form-label-xs">Pilih Tagihan</label>
              <Select value={gatewayBillingId} onValueChange={setGatewayBillingId}>
                <SelectTrigger className="bg-[#0A0A0A] border-white/10 text-white">
                  <SelectValue placeholder="Pilih tagihan belum lunas" />
                </SelectTrigger>
                <SelectContent>
                  {pendingBillingsForGateway.map((item) => (
                    <SelectItem key={item.id} value={item.id}>
                      {item.invoice_number} - {item.customer_name} ({formatCurrency(item.amount || 0)})
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="staff-form-label-xs">Provider</label>
              <Select value={gatewayProvider} onValueChange={setGatewayProvider}>
                <SelectTrigger className="bg-[#0A0A0A] border-white/10 text-white">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="xendit">Xendit</SelectItem>
                  <SelectItem value="midtrans">Midtrans</SelectItem>
                  <SelectItem value="tripay">Tripay</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="staff-form-label-xs">Channel VA</label>
              <Select value={gatewayChannel} onValueChange={setGatewayChannel}>
                <SelectTrigger className="bg-[#0A0A0A] border-white/10 text-white">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="va_bca">VA BCA</SelectItem>
                  <SelectItem value="va_bni">VA BNI</SelectItem>
                  <SelectItem value="va_bri">VA BRI</SelectItem>
                  <SelectItem value="va_mandiri">VA Mandiri</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="flex items-center gap-2 mb-4">
            <Button onClick={handleCreateGatewayPayment} disabled={creatingGatewayPayment || !gatewayBillingId} className="bg-indigo-600 hover:bg-indigo-700 text-white">
              {creatingGatewayPayment ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <CreditCard className="w-4 h-4 mr-2" />}
              Buat Virtual Payment
            </Button>
          </div>

          <div className="space-y-2 max-h-60 overflow-y-auto pr-1">
            {gatewayTransactions.length === 0 ? (
              <p className="text-sm text-gray-500">Belum ada transaksi payment gateway.</p>
            ) : (
              gatewayTransactions.map((tx) => (
                <div key={tx.id} className="rounded-lg border border-white/10 bg-[#0A0A0A] px-3 py-2 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                  <div>
                    <p className="text-sm text-white">{tx.invoice_number} - {tx.customer_name}</p>
                    <p className="text-xs text-gray-400">
                      {tx.provider?.toUpperCase()} / {tx.channel} � VA: {tx.virtual_account_number} � {formatCurrency(tx.amount || 0)}
                    </p>
                    <p className="text-[11px] text-gray-500">Status: {tx.status} � Dibuat: {formatDateTime(tx.created_at)}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    {String(tx.status || '').toLowerCase() !== 'paid' ? (
                      <Button
                        size="sm"
                        className="bg-green-600 hover:bg-green-700 text-white"
                        disabled={simulatingGatewayTxId === tx.id}
                        onClick={() => handleSimulateGatewayPaid(tx.id)}
                      >
                        {simulatingGatewayTxId === tx.id ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <Check className="w-3 h-3 mr-1" />}
                        Simulasi Lunas
                      </Button>
                    ) : (
                      <span className="text-xs px-2 py-1 rounded border border-green-400/30 text-green-300">LUNAS</span>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        <div className="bg-[#121212] rounded-xl p-6 border border-white/10 mb-6">
          <div className="flex items-center justify-between gap-3 mb-4">
            <div>
              <h2 className="font-outfit text-xl font-semibold text-white">Catatan Pembayaran</h2>
              <p className="text-gray-400 text-sm">Sumber: catatan pembayaran + transfer menunggu persetujuan.</p>
            </div>
            <Button onClick={fetchPayments} disabled={loadingPayments} variant="outline" className="btn-secondary">
              {loadingPayments ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
              Muat Ulang Pembayaran
            </Button>
          </div>
          {paymentRows.length === 0 ? (
            <p className="text-sm text-gray-500">Belum ada catatan pembayaran.</p>
          ) : (
            <div className="space-y-2 max-h-96 overflow-y-auto pr-1">
              {paymentRows.slice(0, 60).map((item) => {
                const paymentMeta = getPaymentStatusMeta(item?.status, item?.approval_status);
                return (
                  <div key={item.id} className="rounded-lg border border-white/10 bg-[#0A0A0A] px-3 py-3">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
                      <div>
                        <p className="text-sm text-white">{item.invoice_number} - {item.customer_name}</p>
                        <p className="text-xs text-gray-400 mt-1">{formatCurrency(item.amount || 0)} � {String(item.method || '-').toUpperCase()}</p>
                        <p className="text-[11px] text-gray-500 mt-1">
                          dikirim: {item.submitted_at ? formatDateTime(item.submitted_at) : '-'} � disetujui: {item.approved_at ? formatDateTime(item.approved_at) : '-'} � oleh: {item.approved_by || '-'}
                        </p>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className={`px-2 py-0.5 rounded-full text-[10px] border ${paymentMeta.tone}`}>{paymentMeta.label}</span>
                        {item.proof_url ? (
                          <Button size="sm" variant="outline" className="btn-secondary h-8 text-xs" onClick={() => window.open(`${BASE_URL}${item.proof_url}`, '_blank', 'noopener,noreferrer')}>
                            Bukti
                          </Button>
                        ) : null}
                        <Button size="sm" variant="outline" className="btn-secondary h-8 text-xs" onClick={() => { setBillingWorkspaceTab('invoice'); setBillingSearchQuery(item.invoice_number || String(item.invoice_id || '')); }}>
                          Buka Tagihan
                        </Button>
                        <Button size="sm" variant="outline" className="btn-secondary h-8 text-xs" onClick={() => navigate(`/dadu/pelanggan?search=${encodeURIComponent(item.customer_id || item.customer_name || '')}`)}>
                          Buka Pelanggan
                        </Button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        </>
        )}

        {showPersetujuanWorkspace && (
        <div className="bg-[#121212] rounded-xl p-6 border border-white/10 mb-6">
          <div className="flex items-center justify-between gap-3 mb-4">
            <div>
              <h2 className="font-outfit text-xl font-semibold text-white">Persetujuan Bukti Transfer</h2>
              <p className="text-gray-400 text-sm">Verifikasi pembayaran transfer manual dari portal pelanggan.</p>
              <div className="mt-2 flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center rounded-full border border-amber-400/30 bg-amber-500/10 px-2 py-0.5 text-[11px] font-medium text-amber-300">
                  Menunggu: {pendingPersetujuanCount}
                </span>
                <span className="inline-flex items-center rounded-full border border-cyan-400/30 bg-cyan-500/10 px-2 py-0.5 text-[11px] font-medium text-cyan-300">
                  Nilai: {formatCurrency(pendingVerificationAmount)}
                </span>
              </div>
            </div>
            <Button onClick={fetchTransferSubmissions} disabled={loadingTransferSubmissions} variant="outline" className="btn-secondary">
              {loadingTransferSubmissions ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
              Muat Ulang Transfer
            </Button>
          </div>

          <div className="grid md:grid-cols-3 gap-3 mb-4">
            <Input
              value={transferSubmissionSearch}
              onChange={(e) => setTransferSubmissionSearch(e.target.value)}
              placeholder="Cari tagihan / pelanggan / no rekening"
              className="bg-[#0A0A0A] border-white/10 text-white"
            />
            <Button
              type="button"
              variant="outline"
              className="btn-secondary"
              onClick={handleToggleSelectAllTransfer}
              disabled={!filteredTransferSubmissions.length}
            >
              {allVisibleTransfersSelected ? 'Batal Pilih Semua' : 'Pilih Semua'}
            </Button>
            <Button
              type="button"
              className="bg-green-600 hover:bg-green-700 text-white"
              onClick={handleSetujuiTransferBatch}
              disabled={batchApprovingTransfers || selectedVisibleTransferCount === 0}
            >
              {batchApprovingTransfers ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <Check className="w-4 h-4 mr-2" />}
              Setujui Batch ({selectedVisibleTransferCount})
            </Button>
          </div>

          {filteredTransferSubmissions.length === 0 ? (
            <p className="text-sm text-gray-500">Belum ada bukti transfer menunggu persetujuan.</p>
          ) : (
            <div className="space-y-2 max-h-72 overflow-y-auto pr-1">
              {filteredTransferSubmissions.map((item) => (
                <div key={item.id} className="rounded-lg border border-white/10 bg-[#0A0A0A] px-3 py-3 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                  <div>
                    <p className="text-sm text-white">{item.invoice_number} - {item.customer_name}</p>
                    <p className="text-xs text-gray-400">
                      {item.bank_account_name} � {item.bank_account_number} � {formatCurrency(item.amount || 0)}
                    </p>
                    <p className="text-[11px] text-gray-500">Dikirim: {formatDateTime(item.created_at)}</p>
                    {item.note ? <p className="text-xs text-gray-400 mt-1">Catatan: {item.note}</p> : null}
                    {item.proof_file_url ? (
                      <a
                        href={`${BASE_URL}${item.proof_file_url}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-xs text-brand-blue hover:underline mt-1 inline-block"
                      >
                        Lihat bukti transfer
                      </a>
                    ) : null}
                  </div>
                  <div className="flex gap-2">
                    <label className="inline-flex items-center gap-2 text-xs text-gray-300 mr-2">
                      <input
                        type="checkbox"
                        checked={selectedTransferSubmissionIds.includes(String(item.id))}
                        onChange={() => handleToggleTransferSelection(item.id)}
                        className="h-4 w-4 rounded border-white/20 bg-[#0A0A0A]"
                      />
                      Pilih
                    </label>
                    <Button
                      size="sm"
                      className="bg-green-600 hover:bg-green-700 text-white"
                      onClick={() => handleSetujuiTransferSubmission(item.id)}
                      disabled={processingTransferSubmissionId === item.id}
                    >
                      {processingTransferSubmissionId === item.id ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <Check className="w-3 h-3 mr-1" />}
                      Setujui
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      className="border-red-400/30 text-red-300 hover:bg-red-500/10"
                      onClick={() => handleTolakTransferSubmission(item.id)}
                      disabled={processingTransferSubmissionId === item.id}
                    >
                      Tolak
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        )}
        {showSuspendWorkspace && (
        <div className="bg-[#121212] rounded-xl p-6 border border-white/10 mb-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
            <div>
              <h2 className="font-outfit text-xl font-semibold text-white">Kontrol Suspend Tagihan</h2>
              <p className="text-gray-400 text-sm">Pantau pelanggan yang siap disuspend karena tertunggak dan yang bisa diaktifkan kembali.</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button onClick={fetchTertunggakControl} disabled={loadingTertunggakControl} variant="outline" className="btn-secondary">
                {loadingTertunggakControl ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
                Muat Ulang Status
              </Button>
              <Button onClick={handleManualTertunggakReconcile} disabled={reconcilingTertunggak} variant="outline" className="btn-secondary">
                {reconcilingTertunggak ? <RotateCcw className="w-4 h-4 mr-2 animate-spin" /> : <RotateCcw className="w-4 h-4 mr-2" />}
                Rekonsiliasi Sekarang
              </Button>
              <Button onClick={handleManualReactivateCleared} disabled={reactivatingCleared} className="bg-green-600 hover:bg-green-700 text-white">
                {reactivatingCleared ? <RotateCcw className="w-4 h-4 mr-2 animate-spin" /> : <Check className="w-4 h-4 mr-2" />}
                Aktifkan Kembali yang Bersih
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
            <div className="rounded-xl border border-red-500/20 bg-red-500/10 p-4">
              <p className="text-xs text-red-200/80">Pelanggan Tertunggak</p>
              <p className="text-2xl font-bold text-red-300 mt-1">{Number(overdueControl.summary?.overdue_customer_count || 0)}</p>
              <p className="text-[11px] text-red-100/70 mt-1">{Number(overdueControl.summary?.overdue_invoice_count || 0)} tagihan</p>
            </div>
            <div className="rounded-xl border border-yellow-500/20 bg-yellow-500/10 p-4">
              <p className="text-xs text-yellow-200/80">Siap Disuspend</p>
              <p className="text-2xl font-bold text-yellow-300 mt-1">{Number(overdueControl.summary?.eligible_suspend_count || 0)}</p>
            </div>
            <div className="rounded-xl border border-cyan-500/20 bg-cyan-500/10 p-4">
              <p className="text-xs text-cyan-200/80">Suspend Otomatis Aktif</p>
              <p className="text-2xl font-bold text-cyan-300 mt-1">{Number(overdueControl.summary?.auto_suspended_count || 0)}</p>
            </div>
            <div className="rounded-xl border border-green-500/20 bg-green-500/10 p-4">
              <p className="text-xs text-green-200/80">Siap Reaktivasi</p>
              <p className="text-2xl font-bold text-green-300 mt-1">{Number(overdueControl.summary?.ready_reactivate_count || 0)}</p>
              <p className="text-[11px] text-green-100/70 mt-1">Masa tenggang: {Number(overdueControl.summary?.grace_days || 0)} hari</p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
            {agingBucketCards.map((bucket) => (
              <div key={bucket.key} className={`rounded-xl border p-4 ${bucket.border} ${bucket.bg}`}>
                <p className={`text-xs ${bucket.text}`}>Aging {bucket.label || bucket.fallbackLabel}</p>
                <p className="text-2xl font-bold text-white mt-1">{Number(bucket.customer_count || 0)}</p>
                <div className="mt-2 space-y-1 text-[11px] text-gray-300">
                  <p>{Number(bucket.invoice_count || 0)} tagihan</p>
                  <p>{formatCurrency(bucket.amount_total || 0)}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="rounded-xl border border-white/10 bg-[#0A0A0A] p-4 mb-6">
            <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-3 mb-4">
              <div>
                <h3 className="text-white font-semibold">Daftar Tertunggak Prioritas</h3>
                <p className="text-xs text-gray-500">Urut berdasarkan tunggakan terlama. Cocok untuk tindak lanjut penagihan dan suspend.</p>
              </div>
              <div className="flex flex-col sm:flex-row gap-2">
                <div className="relative">
                  <Search className="w-4 h-4 text-gray-500 absolute left-3 top-1/2 -translate-y-1/2" />
                  <Input
                    value={overdueSearchQuery}
                    onChange={(e) => setTertunggakSearchQuery(e.target.value)}
                    placeholder="Cari pelanggan / tagihan"
                    className="pl-9 w-full sm:w-72 bg-[#121212] border-white/10 text-white"
                  />
                </div>
                <Button onClick={handleExportTertunggakCsv} variant="outline" className="btn-secondary">
                  <Download className="w-4 h-4 mr-2" />
                  Ekspor Tunggakan CSV
                </Button>
              </div>
            </div>

            <div className="space-y-2 max-h-80 overflow-y-auto pr-1">
              {filteredTertunggakCustomers.length === 0 ? (
                <p className="text-sm text-gray-500">Tidak ada pelanggan tertunggak yang cocok dengan filter.</p>
              ) : (
                filteredTertunggakCustomers.slice(0, 20).map((customer) => (
                  <div key={customer.id} className="rounded-lg border border-white/10 px-4 py-3">
                    <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-3">
                      <div>
                        <div className="flex flex-wrap items-center gap-2">
                          <p className="text-sm text-white font-medium">{customer.customer_id || '-'} - {customer.name || '-'}</p>
                          {customer.auto_suspended_by_billing ? (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-cyan-500/30 bg-cyan-500/15 text-cyan-200">Suspend billing</span>
                          ) : customer.eligible_suspend ? (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-yellow-500/30 bg-yellow-500/15 text-yellow-200">Siap suspend</span>
                          ) : (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-red-500/30 bg-red-500/15 text-red-200">Perlu follow-up</span>
                          )}
                        </div>
                        <p className="text-xs text-gray-500 mt-1">
                          Tagihan: {Array.isArray(customer.invoice_numbers) && customer.invoice_numbers.length > 0 ? customer.invoice_numbers.join(', ') : '-'}
                        </p>
                        <p className="text-xs text-gray-500 mt-1">
                          Telepon: {customer.phone || '-'} {customer.oldest_due_date ? `| Jatuh tempo awal: ${formatDate(customer.oldest_due_date)}` : ''}
                        </p>
                      </div>
                      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm min-w-full xl:min-w-[420px]">
                        <div>
                          <p className="text-gray-500 text-[11px]">Tertunggak</p>
                          <p className="text-white font-semibold">{Number(customer.oldest_overdue_days || 0)} hari</p>
                        </div>
                        <div>
                          <p className="text-gray-500 text-[11px]">Tagihan</p>
                          <p className="text-white font-semibold">{Number(customer.overdue_count || 0)}</p>
                        </div>
                        <div>
                          <p className="text-gray-500 text-[11px]">Tunggakan</p>
                          <p className="text-white font-semibold">{formatCurrency(customer.total_overdue_amount || 0)}</p>
                        </div>
                        <div>
                          <p className="text-gray-500 text-[11px]">Waktu Suspend</p>
                          <p className="text-white font-semibold text-xs">{customer.billing_auto_suspended_at ? formatDateTime(customer.billing_auto_suspended_at) : '-'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          <div className="grid xl:grid-cols-2 gap-4">
            <div className="rounded-xl border border-white/10 bg-[#0A0A0A] p-4">
              <div className="flex items-center justify-between gap-3 mb-3">
                <div>
                  <h3 className="text-white font-semibold">Siap Disuspend</h3>
                  <p className="text-xs text-gray-500">Pelanggan aktif dengan tagihan tertunggak yang sudah melewati masa tenggang.</p>
                </div>
                <span className="text-xs text-yellow-300">{Number(overdueControl.summary?.eligible_suspend_count || 0)} pelanggan</span>
              </div>
              <div className="space-y-2 max-h-56 overflow-y-auto pr-1">
                {(overdueControl.eligible_suspend_customers || []).length === 0 ? (
                  <p className="text-sm text-gray-500">Tidak ada pelanggan yang siap disuspend saat ini.</p>
                ) : (
                  overdueControl.eligible_suspend_customers.slice(0, 12).map((customer) => (
                    <div key={customer.id} className="rounded-lg border border-white/10 px-3 py-2">
                      <div className="flex items-center justify-between gap-3">
                        <div>
                          <p className="text-sm text-white">{customer.customer_id || '-'} - {customer.name || '-'}</p>
                          <p className="text-xs text-gray-500 mt-1">Tagihan: {(customer.invoice_numbers || []).join(', ') || '-'} </p>
                        </div>
                        <span className="text-[11px] text-yellow-300">{Number(customer.overdue_count || 0)} tertunggak</span>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>

            <div className="rounded-xl border border-white/10 bg-[#0A0A0A] p-4">
              <div className="flex items-center justify-between gap-3 mb-3">
                <div>
                  <h3 className="text-white font-semibold">Siap Diaktifkan Kembali</h3>
                  <p className="text-xs text-gray-500">Pelanggan yang sebelumnya disuspend otomatis oleh billing dan sekarang tidak punya tunggakan tersisa.</p>
                </div>
                <span className="text-xs text-green-300">{Number(overdueControl.summary?.ready_reactivate_count || 0)} pelanggan</span>
              </div>
              <div className="space-y-2 max-h-56 overflow-y-auto pr-1">
                {(overdueControl.reactivation_candidates || []).length === 0 ? (
                  <p className="text-sm text-gray-500">Belum ada pelanggan yang siap direaktivasi.</p>
                ) : (
                  overdueControl.reactivation_candidates.slice(0, 12).map((customer) => (
                    <div key={customer.id} className="rounded-lg border border-white/10 px-3 py-2">
                      <div className="flex items-center justify-between gap-3">
                        <div>
                          <p className="text-sm text-white">{customer.customer_id || '-'} - {customer.name || '-'}</p>
                          <p className="text-xs text-gray-500 mt-1">Suspend sejak: {formatDateTime(customer.billing_auto_suspended_at)}</p>
                        </div>
                        <span className="text-[11px] text-green-300">Siap aktif</span>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
        )}

        {showEventsWorkspace && (
        <div className="bg-[#121212] rounded-xl p-6 border border-white/10 mb-6">
          <div className="flex items-center justify-between gap-3 mb-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-brand-blue/15 flex items-center justify-center">
                <History className="w-5 h-5 text-brand-blue" />
              </div>
              <div>
                <h2 className="font-outfit text-xl font-semibold text-white">Kejadian Tagihan (Audit Engine)</h2>
                <p className="text-gray-400 text-sm">Sumber: billing_events (tipe kejadian, transisi status, pelaku, waktu kejadian).</p>
              </div>
            </div>
            <Button onClick={fetchBillingEvents} disabled={loadingBillingEvents} variant="outline" className="btn-secondary">
              {loadingBillingEvents ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
              Muat Ulang Kejadian
            </Button>
          </div>

          <div className="space-y-3">
            {loadingBillingEvents ? (
              <p className="text-sm text-gray-500">Memuat kejadian tagihan...</p>
            ) : billingEventRows.length === 0 ? (
              <p className="text-sm text-gray-500">Belum ada kejadian tagihan.</p>
            ) : (
              billingEventRows.slice(0, 80).map((event) => (
                <div key={event.id} className="rounded-lg border border-white/10 bg-[#0A0A0A] p-4">
                  <div className="flex flex-col md:flex-row md:items-start justify-between gap-3">
                    <div>
                      <p className="text-sm font-semibold text-white">{event.event_type || '-'}</p>
                      <p className="text-xs text-gray-300 mt-1">
                        pelanggan: {event.customer_id || '-'} � tagihan: {event.invoice_id || event.invoice_number || '-'} � pembayaran: {event.payment_id || '-'}
                      </p>
                      <p className="text-xs text-gray-500 mt-2">
                        {formatDateTime(event.event_at || event.created_at)} � pelaku: {event.actor_type || 'system'}{event.actor_id ? ` (${event.actor_id})` : ''}
                      </p>
                    </div>
                    <div className="text-left md:text-right text-xs text-gray-400">
                      <p>dari: <span className="text-amber-300">{event.from_state || '-'}</span></p>
                      <p>ke: <span className="text-emerald-300">{event.to_state || '-'}</span></p>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
        )}

        {showPersetujuanWorkspace && (
        <div className="grid xl:grid-cols-2 gap-6 mb-6">
          <div className="bg-[#121212] rounded-xl p-6 border border-white/10">
            <div className="flex items-center justify-between gap-3 mb-4">
              <div>
                <h2 className="font-outfit text-xl font-semibold text-white">Kesehatan Sinkronisasi FreeRADIUS</h2>
                <p className="text-gray-400 text-sm">Ringkasan hasil sinkronisasi terakhir per pelanggan.</p>
              </div>
              <div className="flex gap-2">
                <Button onClick={() => { fetchFreeradiusSyncSummary(); fetchFreeradiusQueue(); }} disabled={loadingFreeradiusSyncSummary || loadingFreeradiusQueue} variant="outline" className="btn-secondary">
                  {loadingFreeradiusSyncSummary ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
                  Muat Ulang
                </Button>
                {freeradiusQueueGuard.paused ? (
                  <Button onClick={handleResumeFreeradiusQueue} disabled={resumingQueue} variant="outline" className="btn-secondary">
                    {resumingQueue ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <RotateCcw className="w-4 h-4 mr-2" />}
                    Lanjutkan Antrean
                  </Button>
                ) : (
                  <Button onClick={handlePauseFreeradiusQueue} disabled={pausingQueue} variant="outline" className="btn-secondary">
                    {pausingQueue ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <AlertTriangle className="w-4 h-4 mr-2" />}
                    Jeda Antrean
                  </Button>
                )}
                <Button onClick={handleSyncWithLog} disabled={enqueueingFreeradiusSync || freeradiusQueueGuard.paused} variant="outline" className="btn-secondary">
                  {enqueueingFreeradiusSync ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <RotateCcw className="w-4 h-4 mr-2" />}
                  Sinkronkan Antrean
                </Button>
              </div>
            </div>

            <div className="mb-4 grid grid-cols-2 md:grid-cols-4 gap-3">
              <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
                <p className="text-xs text-gray-400">Sumber GenieACS</p>
                <p className="text-sm font-semibold text-white mt-1">{systemSource}</p>
              </div>
              <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
                <p className="text-xs text-gray-400">Latency avg/p95</p>
                <p className="text-sm font-semibold text-white mt-1">{systemLatencyAvg} / {systemLatencyP95}</p>
              </div>
              <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
                <p className="text-xs text-gray-400">Setujui Transfer</p>
                <p className="text-sm font-semibold text-green-300 mt-1">{systemTransferSuccess} sukses</p>
              </div>
              <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
                <p className="text-xs text-gray-400">Konflik/Gagal</p>
                <p className="text-sm font-semibold text-yellow-300 mt-1">{systemTransferConflict} / <span className="text-red-300">{systemTransferFail}</span></p>
              </div>
            </div>
            <div className="mb-4 grid grid-cols-2 md:grid-cols-3 gap-3">
              <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
                <p className="text-xs text-gray-400">Transfer Menunggu</p>
                <p className="text-sm font-semibold text-cyan-300 mt-1">{systemTransferPending}</p>
              </div>
              <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
                <p className="text-xs text-gray-400">Belum Bayar/Tertunggak</p>
                <p className="text-sm font-semibold text-amber-300 mt-1">{systemUnpaidTertunggak}</p>
              </div>
              <div className="rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
                <p className="text-xs text-gray-400">Antrian Terbuka</p>
                <p className="text-sm font-semibold text-indigo-300 mt-1">{systemRadiusQueueOpen}</p>
              </div>
            </div>

            {freeradiusQueueGuard.paused && (
              <div className="mb-3 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                <p className="text-xs text-red-200">
                  Antrean FreeRADIUS sedang jeda otomatis. Gagal beruntun: {Number(freeradiusQueueGuard.consecutive_failures || 0)} / {Number(freeradiusQueueGuard.pause_threshold || 5)}.
                </p>
                <Button onClick={handleResumeFreeradiusQueue} disabled={resumingQueue} variant="outline" className="btn-secondary h-8 px-3 text-xs">
                  {resumingQueue ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <RotateCcw className="w-3 h-3 mr-1" />}
                  Lanjutkan Antrean
                </Button>
              </div>
            )}

            <div className="grid grid-cols-3 gap-3 mb-3">
              <div className="rounded-lg border border-green-500/20 bg-green-500/10 p-3">
                <p className="text-xs text-green-200/80">Berhasil</p>
                <p className="text-xl font-bold text-green-300">{Number(freeradiusSyncSummary.summary?.success || 0)}</p>
              </div>
              <div className="rounded-lg border border-red-500/20 bg-red-500/10 p-3">
                <p className="text-xs text-red-200/80">Gagal</p>
                <p className="text-xl font-bold text-red-300">{Number(freeradiusSyncSummary.summary?.error || 0)}</p>
              </div>
              <div className="rounded-lg border border-yellow-500/20 bg-yellow-500/10 p-3">
                <p className="text-xs text-yellow-200/80">Dilewati</p>
                <p className="text-xl font-bold text-yellow-300">{Number(freeradiusSyncSummary.summary?.skipped || 0)}</p>
              </div>
            </div>

            <div className="grid grid-cols-4 gap-3 mb-4">
              <div className="rounded-lg border border-sky-500/20 bg-sky-500/10 p-3">
                <p className="text-xs text-sky-200/80">Mengantre</p>
                <p className="text-lg font-bold text-sky-300">{Number(freeradiusQueue.summary?.queued || 0)}</p>
              </div>
              <div className="rounded-lg border border-amber-500/20 bg-amber-500/10 p-3">
                <p className="text-xs text-amber-200/80">Coba Ulang</p>
                <p className="text-lg font-bold text-amber-300">{Number(freeradiusQueue.summary?.retry || 0)}</p>
              </div>
              <div className="rounded-lg border border-indigo-500/20 bg-indigo-500/10 p-3">
                <p className="text-xs text-indigo-200/80">Diproses</p>
                <p className="text-lg font-bold text-indigo-300">{Number(freeradiusQueue.summary?.processing || 0)}</p>
              </div>
              <div className="rounded-lg border border-rose-500/20 bg-rose-500/10 p-3">
                <p className="text-xs text-rose-200/80">Gagal</p>
                <p className="text-lg font-bold text-rose-300">{Number(freeradiusQueue.summary?.failed || 0)}</p>
              </div>
            </div>

            <div className="mb-4 rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                <div>
                  <p className="text-sm font-semibold text-white">Pengaturan Penjaga Antrean</p>
                  <p className="text-xs text-gray-400">Jeda otomatis antrean jika gagal berturut-turut mencapai ambang batas.</p>
                </div>
                <div className="flex items-center gap-2">
                  <Input
                    type="number"
                    min={3}
                    max={20}
                    value={freeradiusGuardSettings.pause_threshold}
                    onChange={(e) => setFreeradiusGuardSettings((prev) => ({ ...prev, pause_threshold: e.target.value }))}
                    className="w-24 bg-[#121212] border-white/10 text-white"
                  />
                  <Button onClick={handleSaveFreeradiusGuardSettings} disabled={savingFreeradiusGuard} variant="outline" className="btn-secondary h-9 px-3 text-xs">
                    {savingFreeradiusGuard ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <Settings className="w-3 h-3 mr-1" />}
                    Simpan
                  </Button>
                </div>
              </div>
            </div>

            <div className="mb-4 rounded-lg border border-white/10 bg-[#0A0A0A] p-3">
              <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
                <p className="text-sm font-semibold text-white">Grafik Antrean {metricsRangeHours} Jam</p>
                <div className="flex items-center gap-2">
                  <Select value={metricsRangeHours} onValueChange={setMetricsRangeHours}>
                    <SelectTrigger className="h-8 w-[110px] bg-[#121212] border-white/10 text-white">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="24">24 Jam</SelectItem>
                      <SelectItem value="48">48 Jam</SelectItem>
                      <SelectItem value="168">7 Hari</SelectItem>
                    </SelectContent>
                  </Select>
                  <Button onClick={fetchFreeradiusQueueMetrics} disabled={loadingFreeradiusMetrics} variant="outline" className="btn-secondary h-8 px-3 text-xs">
                    {loadingFreeradiusMetrics ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <RefreshCw className="w-3 h-3 mr-1" />}
                    Muat Ulang
                  </Button>
                </div>
              </div>
              {freeradiusMetrics.length === 0 ? (
                <p className="text-xs text-gray-500">Belum ada data metrik antrean.</p>
              ) : (
                <div className="space-y-1 max-h-36 overflow-y-auto pr-1">
                  {(() => {
                    const maxVal = Math.max(...freeradiusMetrics.map((it) => Number(it.success || 0) + Number(it.failed || 0) + Number(it.retry || 0)), 1);
                    return freeradiusMetrics.slice(-12).map((item) => {
                      const ok = Number(item.success || 0);
                      const bad = Number(item.failed || 0) + Number(item.retry || 0);
                      const total = ok + bad;
                      const okWidth = total > 0 ? (ok / maxVal) * 100 : 0;
                      const badWidth = total > 0 ? (bad / maxVal) * 100 : 0;
                      const label = new Date(item.hour).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' });
                      return (
                        <div key={item.hour} className="flex items-center gap-2">
                          <span className="w-12 text-[10px] text-gray-400">{label}</span>
                          <div className="flex-1 h-2 rounded bg-white/5 overflow-hidden">
                            <div className="h-full bg-green-400/80" style={{ width: `${okWidth}%` }} />
                            <div className="h-full bg-red-400/80 -mt-2" style={{ width: `${badWidth}%`, marginLeft: `${okWidth}%` }} />
                          </div>
                          <span className="w-16 text-[10px] text-gray-400 text-right">{ok}/{bad}</span>
                        </div>
                      );
                    });
                  })()}
                </div>
              )}
            </div>

            <div className="space-y-2 max-h-72 overflow-y-auto pr-1">
              {(freeradiusSyncSummary.items || []).length === 0 ? (
                <p className="text-sm text-gray-500">Belum ada log sinkronisasi FreeRADIUS.</p>
              ) : (
                (freeradiusSyncSummary.items || []).slice(0, 20).map((item) => (
                  <div key={item.id} className="rounded-lg border border-white/10 bg-[#0A0A0A] px-3 py-2">
                    <div className="flex items-center justify-between gap-2">
                      <p className="text-sm text-white">{item.customer_code || '-'} - {item.customer_name || '-'}</p>
                      <span className={`text-[11px] ${item.status === 'success' ? 'text-green-300' : item.status === 'error' ? 'text-red-300' : 'text-yellow-300'}`}>
                        {item.status || '-'}
                      </span>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">{item.action || '-'} | {formatDateTime(item.created_at)}</p>
                    {item.error && <p className="text-xs text-red-300 mt-1">{item.error}</p>}
                  </div>
                ))
              )}
            </div>

            <div className="mt-4 border-t border-white/10 pt-4">
                  <h3 className="text-sm font-semibold text-white mb-2">Antrean Sinkronisasi Terakhir</h3>
              <div className="flex flex-col md:flex-row gap-2 md:items-center md:justify-between mb-2">
                <Select value={queueStatusFilter} onValueChange={setQueueStatusFilter}>
                  <SelectTrigger className="w-full md:w-44 bg-[#0A0A0A] border-white/10 text-white">
                    <SelectValue placeholder="Penyaring status" />
                  </SelectTrigger>
                  <SelectContent className="bg-[#121212] border-white/10 text-white">
                    <SelectItem value="all">Semua Status</SelectItem>
                    <SelectItem value="queued">Queued</SelectItem>
                    <SelectItem value="retry">Retry</SelectItem>
                    <SelectItem value="processing">Processing</SelectItem>
                    <SelectItem value="success">Success</SelectItem>
                    <SelectItem value="failed">Failed</SelectItem>
                  </SelectContent>
                </Select>
                <Button
                  onClick={handleRetryAllFailedQueues}
                  disabled={retryingAllQueues}
                  variant="outline"
                  className="btn-secondary h-9 px-3 text-xs"
                >
                  {retryingAllQueues ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <RotateCcw className="w-3 h-3 mr-1" />}
                  Ulangi Semua yang Gagal
                </Button>
                <Button onClick={handleExportFreeradiusQueueCsv} variant="outline" className="btn-secondary h-9 px-3 text-xs">
                  <Download className="w-3 h-3 mr-1" />
                  Ekspor CSV
                </Button>
              </div>
              <div className="space-y-2 max-h-56 overflow-y-auto pr-1">
                {(freeradiusQueue.items || []).length === 0 ? (
                  <p className="text-sm text-gray-500">Belum ada antrean sinkronisasi.</p>
                ) : (
                  (freeradiusQueue.items || []).slice(0, 10).map((job) => {
                    const status = String(job?.status || '-');
                    const isFailed = status === 'failed' || status === 'retry';
                    return (
                      <div key={job.id} className="rounded-lg border border-white/10 bg-[#0A0A0A] px-3 py-2">
                        <div className="flex items-center justify-between gap-2">
                          <p className="text-sm text-white">{job.trigger || 'manual_queue'}</p>
                          <span className={`text-[11px] ${
                            status === 'success' ? 'text-green-300'
                              : status === 'failed' ? 'text-red-300'
                                : status === 'processing' ? 'text-indigo-300'
                                  : status === 'retry' ? 'text-amber-300'
                                    : 'text-sky-300'
                          }`}>
                            {status}
                          </span>
                        </div>
                        <p className="text-xs text-gray-500 mt-1">
                          Attempt: {Number(job.attempt_count || 0)} / {Number(job.max_attempts || 0)} | {formatDateTime(job.updated_at || job.created_at)}
                        </p>
                        <p className="text-xs text-gray-500 mt-1">
                          Durasi: {job.duration_ms != null ? `${Number(job.duration_ms)} ms` : '-'}
                        </p>
                        {job.last_error && <p className="text-xs text-red-300 mt-1 break-words">{job.last_error}</p>}
                        {isFailed && (
                          <div className="mt-2">
                            <Button
                              onClick={() => handleRetryQueueJob(job.id)}
                              disabled={retryingQueueId === job.id}
                              variant="outline"
                              className="btn-secondary h-8 px-3 text-xs"
                            >
                              {retryingQueueId === job.id ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <RotateCcw className="w-3 h-3 mr-1" />}
                              Retry
                            </Button>
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>

          <div className="bg-[#121212] rounded-xl p-6 border border-white/10">
            <div className="flex items-center justify-between gap-3 mb-4">
              <div>
                <h2 className="font-outfit text-xl font-semibold text-white">Isolation Timeline</h2>
                <p className="text-gray-400 text-sm">Riwayat isolasi/buka kembali akibat tunggakan billing.</p>
              </div>
              <Button onClick={fetchIsolationLogs} disabled={loadingIsolationLogs} variant="outline" className="btn-secondary">
                {loadingIsolationLogs ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
                Muat Ulang
              </Button>
            </div>

            <div className="space-y-2 max-h-96 overflow-y-auto pr-1">
              {isolationLogs.length === 0 ? (
                <p className="text-sm text-gray-500">Belum ada event isolation.</p>
              ) : (
                isolationLogs.slice(0, 30).map((item) => (
                  <div key={item.id} className="rounded-lg border border-white/10 bg-[#0A0A0A] px-3 py-2">
                    <div className="flex items-center justify-between gap-2">
                      <p className="text-sm text-white">{item.customer_code || '-'} - {item.customer_name || '-'}</p>
                      <span className={`text-[11px] ${item.action === 'isolate' ? 'text-red-300' : 'text-green-300'}`}>
                        {item.action === 'isolate' ? 'Isolate' : 'Reopen'}
                      </span>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">{formatDateTime(item.created_at)} | {item.reason || '-'}</p>
                    <p className="text-xs text-gray-500">Tagihan: {(item.invoice_numbers || []).join(', ') || '-'}</p>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        )}

        {showCustomerWorkspace && (
        <div className="bg-[#121212] rounded-xl p-6 border border-white/10 mb-6">
          <div className="flex items-center justify-between gap-3 mb-4">
            <div>
              <h2 className="font-outfit text-xl font-semibold text-white">Ringkasan Billing Pelanggan</h2>
              <p className="text-gray-400 text-sm">Sumber: ringkasan billing pelanggan (status/tempo/tertunggak/suspend).</p>
            </div>
            <Button onClick={refreshBillingData} variant="outline" className="btn-secondary">
              <RefreshCw className="w-4 h-4 mr-2" />
              Muat Ulang
            </Button>
          </div>
          {customerBillingRows.length === 0 ? (
            <p className="text-sm text-gray-500">Belum ada data pelanggan billing.</p>
          ) : (
            <div className="space-y-2 max-h-[620px] overflow-y-auto pr-1">
              {customerBillingRows.map((row) => {
                const stateMeta = getBillingStateMeta(row.state);
                const insight = customerEventInsightById[row.customer_id] || {};
                const showSuspendAction = row.state === 'overdue' || row.state === 'kandidat_suspend' || row.suspend_eligible;
                const showRestoreAction = row.state === 'restore_candidate';
                return (
                  <div key={row.customer_id} className="rounded-lg border border-white/10 bg-[#0A0A0A] px-3 py-3">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
                      <div>
                        <p className="text-sm text-white font-semibold">{row.customer?.customer_id || '-'} - {row.customer?.name || '-'}</p>
                        <p className="text-xs text-gray-400 mt-1">{row.package_name}</p>
                        <div className="mt-2 flex flex-wrap items-center gap-2">
                          <span className={`px-2 py-0.5 rounded-full text-[10px] border ${stateMeta.tone}`}>{stateMeta.label}</span>
                          <span className="px-2 py-0.5 rounded-full text-[10px] border border-slate-500/30 bg-slate-500/10 text-slate-200">
                            jatuh_tempo: {row.due_date ? formatDate(row.due_date) : '-'}
                          </span>
                          <span className="px-2 py-0.5 rounded-full text-[10px] border border-red-500/30 bg-red-500/10 text-red-200">
                            overdue_days: {Number(row.overdue_days || 0)}
                          </span>
                          <span className={`px-2 py-0.5 rounded-full text-[10px] border ${row.suspend_eligible ? 'border-yellow-500/30 bg-yellow-500/10 text-yellow-200' : 'border-slate-500/30 bg-slate-500/10 text-slate-200'}`}>
                            suspend_eligible: {row.suspend_eligible ? 'true' : 'false'}
                          </span>
                          <span className="px-2 py-0.5 rounded-full text-[10px] border border-cyan-500/30 bg-cyan-500/10 text-cyan-200">
                            pembayaran_terakhir: {row.last_payment_at ? formatDateTime(row.last_payment_at) : '-'}
                          </span>
                          {insight.overdueTriggered >= 3 ? (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-red-500/30 bg-red-500/10 text-red-200">Tertunggak {insight.overdueTriggered}x/90h</span>
                          ) : null}
                          {insight.suspendCandidate >= 2 ? (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-fuchsia-500/30 bg-fuchsia-500/10 text-fuchsia-200">Repeated kandidat suspend</span>
                          ) : null}
                          {insight.restoreMarked > 0 ? (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-emerald-500/30 bg-emerald-500/10 text-emerald-200">Baru dipulihkan</span>
                          ) : null}
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        <Button size="sm" variant="outline" className="btn-secondary h-8 text-xs" onClick={() => navigate(`/dadu/pelanggan?search=${encodeURIComponent(row.customer?.customer_id || row.customer?.name || '')}`)}>
                          Buka Pelanggan
                        </Button>
                        {row.last_invoice_id ? (
                          <Button size="sm" variant="outline" className="btn-secondary h-8 text-xs" onClick={() => { setBillingWorkspaceTab('invoice'); setBillingSearchQuery(row.last_invoice_number || row.last_invoice_id); }}>
                            Buka Tagihan
                          </Button>
                        ) : null}
                        {showSuspendAction ? (
                          <Button size="sm" variant="outline" className="btn-secondary h-8 text-xs" onClick={() => { setBillingWorkspaceTab('suspend'); setTertunggakSearchQuery(row.customer?.name || row.customer?.customer_id || ''); }}>
                            Tinjau Suspend
                          </Button>
                        ) : null}
                        {showRestoreAction ? (
                          <Button size="sm" variant="outline" className="btn-secondary h-8 text-xs" onClick={() => { setBillingWorkspaceTab('suspend'); setTertunggakSearchQuery(row.customer?.name || row.customer?.customer_id || ''); }}>
                            Pulihkan Layanan
                          </Button>
                        ) : null}
                        <Button size="sm" variant="outline" className="btn-secondary h-8 text-xs" onClick={() => setBillingWorkspaceTab('events')}>
                          Lihat Kejadian Tagihan
                        </Button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        )}

        {showTagihanWorkspace && (
        <>
        {/* Tagihan View */}
        <div className="grid sm:grid-cols-3 gap-2 mb-4">
          <button
            type="button"
            onClick={() => setBillingView('all')}
            className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${billingView === 'all' ? 'bg-brand-blue/10 text-brand-blue border-brand-blue/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}
          >
            Semua Tagihan
          </button>
          <button
            type="button"
            onClick={() => setBillingView('period')}
            className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${billingView === 'period' ? 'bg-brand-blue/10 text-brand-blue border-brand-blue/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}
          >
            Tagihan Periode
          </button>
          <button
            type="button"
            onClick={() => setBillingView('verification')}
            className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${billingView === 'verification' ? 'bg-brand-blue/10 text-brand-blue border-brand-blue/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}
          >
            Menunggu Verifikasi ({pendingVerificationCount})
          </button>
        </div>

        <div className="grid sm:grid-cols-3 gap-2 mb-4">
          <button
            type="button"
            onClick={() => setTagihanFocus('operational')}
            className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${invoiceFocus === 'operational' ? 'bg-red-500/10 text-red-300 border-red-500/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}
          >
            Fokus Operasional
          </button>
          <button
            type="button"
            onClick={() => setTagihanFocus('all')}
            className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${invoiceFocus === 'all' ? 'bg-brand-blue/10 text-brand-blue border-brand-blue/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}
          >
            Semua Tagihan
          </button>
          <button
            type="button"
            onClick={() => setTagihanFocus('paid_only')}
            className={`rounded-lg border px-4 py-2 text-sm text-left transition-colors ${invoiceFocus === 'paid_only' ? 'bg-emerald-500/10 text-emerald-300 border-emerald-500/30' : 'bg-[#121212] text-gray-300 border-white/10 hover:border-white/20'}`}
          >
            Arsip Lunas
          </button>
        </div>

        {/* Filters */}
        <div className="ktc-filter-bar mb-6 flex flex-wrap items-center gap-3">
          <Input
            value={billingSearchQuery}
            onChange={(e) => setBillingSearchQuery(e.target.value)}
            placeholder="Cari nama / no internet / tagihan"
            className="w-full sm:w-64 bg-[#0A0A0A] border-white/10 text-white placeholder:text-gray-500"
          />
          <Select value={filterStatus || undefined} onValueChange={(v) => setFilterStatus(v === 'all' ? '' : v)}>
            <SelectTrigger className="w-40 bg-[#0A0A0A] border-white/10 text-white">
              <SelectValue placeholder="Status" />
            </SelectTrigger>
            <SelectContent className="bg-[#121212] border-white/10">
              <SelectItem value="all" className="text-white">Semua Status</SelectItem>
              <SelectItem value="paid" className="text-white">Lunas</SelectItem>
              <SelectItem value="unpaid" className="text-white">Belum Bayar</SelectItem>
              <SelectItem value="overdue" className="text-white">Jatuh Tempo</SelectItem>
            </SelectContent>
          </Select>
          <Select value={filterMonth || undefined} onValueChange={(v) => setFilterMonth(v === 'all' ? '' : v)}>
            <SelectTrigger className="w-40 bg-[#0A0A0A] border-white/10 text-white">
              <SelectValue placeholder="Bulan" />
            </SelectTrigger>
            <SelectContent className="bg-[#121212] border-white/10">
              <SelectItem value="all" className="text-white">Semua Bulan</SelectItem>
              {months.map(m => (
                <SelectItem key={m.value} value={m.value} className="text-white">{m.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Select value={filterYear} onValueChange={setFilterYear}>
            <SelectTrigger className="w-32 bg-[#0A0A0A] border-white/10 text-white">
              <SelectValue placeholder="Tahun" />
            </SelectTrigger>
            <SelectContent className="bg-[#121212] border-white/10">
              {[2024, 2025, 2026, 2027].map(y => (
                <SelectItem key={y} value={y.toString()} className="text-white">{y}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Select value={filterBukti || undefined} onValueChange={(v) => setFilterBukti(v === 'all' ? '' : v)}>
            <SelectTrigger className="w-48 bg-[#121212] border-white/10 text-white">
              <SelectValue placeholder="Bukti Pembayaran" />
            </SelectTrigger>
            <SelectContent className="bg-[#121212] border-white/10">
              <SelectItem value="all" className="text-white">Semua Bukti</SelectItem>
              <SelectItem value="with" className="text-white">Ada Bukti</SelectItem>
              <SelectItem value="without" className="text-white">Belum Ada Bukti</SelectItem>
            </SelectContent>
          </Select>
          <Select value={filterPaymentMethod} onValueChange={setFilterPaymentMethod}>
            <SelectTrigger className="w-48 bg-[#121212] border-white/10 text-white">
              <SelectValue placeholder="Metode Bayar" />
            </SelectTrigger>
            <SelectContent className="bg-[#121212] border-white/10">
              <SelectItem value="all" className="text-white">Semua Metode</SelectItem>
              <SelectItem value="cash" className="text-white">Cash</SelectItem>
              <SelectItem value="transfer" className="text-white">Transfer</SelectItem>
              <SelectItem value="gateway" className="text-white">Payment Gateway</SelectItem>
            </SelectContent>
          </Select>
          <Select value={printMode} onValueChange={setPrintMode}>
            <SelectTrigger className="w-56 bg-[#0A0A0A] border-white/10 text-white">
              <SelectValue placeholder="Mode Print" />
            </SelectTrigger>
            <SelectContent className="bg-[#121212] border-white/10">
              <SelectItem value="standard" className="text-white">Printer Standar (A4 PDF)</SelectItem>
              <SelectItem value="thermal" className="text-white">Printer Thermal Bluetooth</SelectItem>
              <SelectItem value="dotmatrix" className="text-white">Printer Dot Matrix</SelectItem>
            </SelectContent>
          </Select>
          <Button
            type="button"
            variant="outline"
            className="btn-secondary h-10"
            onClick={() => {
              const now = new Date();
              setFilterMonth(String(now.getMonth() + 1));
              setFilterYear(String(now.getFullYear()));
            }}
          >
            Bulan Ini
          </Button>
          <Button
            type="button"
            variant="outline"
            className="btn-secondary h-10"
            onClick={() => {
              setBillingSearchQuery('');
              setFilterStatus('');
              setFilterMonth('');
              setFilterBukti('');
              setFilterPaymentMethod('all');
              setFilterYear(new Date().getFullYear().toString());
              setBillingView('all');
              setTagihanFocus('operational');
            }}
          >
            Reset Filter
          </Button>
        </div>
        </>
        )}
        {billingSearchSourceLabel && (
          <div className="mb-4 rounded-lg border border-cyan-500/30 bg-cyan-500/10 px-3 py-2">
            <p className="text-xs text-cyan-200">
              {billingSearchSourceLabel}. Kata kunci saat ini: <span className="font-semibold text-cyan-100">{billingSearchQuery || '-'}</span>
            </p>
          </div>
        )}

        {/* Billing List */}
        {loading ? (
          <div className="text-center py-20">
            <div className="w-12 h-12 border-4 border-brand-blue border-t-transparent rounded-full animate-spin mx-auto" />
          </div>
        ) : !periodReady ? (
          <div className="text-center py-20 bg-[#121212] rounded-xl border border-white/10">
            <Calendar className="w-16 h-16 text-gray-600 mx-auto mb-4" />
            <p className="text-gray-400 text-lg">Pilih bulan dan tahun untuk melihat tagihan periode</p>
          </div>
        ) : displayedBillings.length === 0 ? (
          <div className="text-center py-20 bg-[#121212] rounded-xl border border-white/10">
            <CreditCard className="w-16 h-16 text-gray-600 mx-auto mb-4" />
            <p className="text-gray-400 text-lg">Belum ada tagihan</p>
          </div>
        ) : (
          <div className="space-y-3">
            <div className="ktc-pagination-bar flex flex-col gap-3 rounded-xl px-3 py-2 md:flex-row md:items-center md:justify-between">
              <p className="text-xs">
                Menampilkan {(billingPage - 1) * billingPerPage + 1}-{Math.min(billingPage * billingPerPage, totalDisplayedBillings)} dari {totalDisplayedBillings} tagihan
              </p>
              <div className="flex flex-wrap items-center gap-2">
                <Select value={String(billingPerPage)} onValueChange={(v) => setBillingPerPage(Number(v))}>
                  <SelectTrigger className="h-8 w-[130px] bg-[#0A0A0A] border-white/10 text-xs text-white">
                    <SelectValue placeholder="Baris/halaman" />
                  </SelectTrigger>
                  <SelectContent className="bg-[#121212] border-white/10">
                    <SelectItem value="10" className="text-white">10 / halaman</SelectItem>
                    <SelectItem value="20" className="text-white">20 / halaman</SelectItem>
                    <SelectItem value="50" className="text-white">50 / halaman</SelectItem>
                    <SelectItem value="100" className="text-white">100 / halaman</SelectItem>
                  </SelectContent>
                </Select>
                <Button type="button" variant="outline" className="btn-secondary h-8 px-3 text-xs" disabled={billingPage <= 1} onClick={() => setBillingPage(1)}>
                  Awal
                </Button>
                <Button type="button" variant="outline" className="btn-secondary h-8 px-3 text-xs" disabled={billingPage <= 1} onClick={() => setBillingPage((p) => Math.max(1, p - 1))}>
                  Sebelumnya
                </Button>
                <span className="text-xs">Hal {billingPage}/{totalBillingPages}</span>
                <Button type="button" variant="outline" className="btn-secondary h-8 px-3 text-xs" disabled={billingPage >= totalBillingPages} onClick={() => setBillingPage((p) => Math.min(totalBillingPages, p + 1))}>
                  Berikutnya
                </Button>
                <Button type="button" variant="outline" className="btn-secondary h-8 px-3 text-xs" disabled={billingPage >= totalBillingPages} onClick={() => setBillingPage(totalBillingPages)}>
                  Akhir
                </Button>
              </div>
            </div>
            {pagedBillings.map((billing, index) => {
              const StatusIcon = statusIcons[billing.status];
              const pendingSubmission = pendingTransferByBillingId[String(billing.id || '')] || null;
              const engineState = resolveBillingEngineState(billing);
              const tagihanMeta = getTagihanStatusMeta(billing?.status);
              const linkedPayment = paymentByTagihanId[String(billing?.id || '').trim()];
              const paymentMeta = getPaymentStatusMeta(linkedPayment?.status, linkedPayment?.approval_status);
              const dueDateValue = billing?.due_date ? new Date(billing.due_date) : null;
              const nowDate = new Date();
              const overdueDays = dueDateValue && String(billing?.status || '').toLowerCase() !== 'paid'
                ? Math.max(0, Math.floor((nowDate.getTime() - dueDateValue.getTime()) / (1000 * 60 * 60 * 24)))
                : 0;
              return (
                <motion.div
                  key={billing.id}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.03 }}
                  className="ktc-list-card bg-[#121212] rounded-xl p-4 border border-white/10 hover:border-white/20 transition-colors"
                >
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="flex items-start gap-4">
                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                        billing.status === 'paid' ? 'bg-green-500/20' : 
                        billing.status === 'unpaid' ? 'bg-yellow-500/20' : 'bg-red-500/20'
                      }`}>
                        <StatusIcon className={`w-5 h-5 ${
                          billing.status === 'paid' ? 'text-green-400' : 
                          billing.status === 'unpaid' ? 'text-yellow-400' : 'text-red-400'
                        }`} />
                      </div>
                      <div>
                        <p className="text-brand-blue font-mono text-sm">{billing.invoice_number}</p>
                        <p className="text-white font-medium">{billing.customer_name}</p>
                        <p className="text-gray-500 text-sm">{billing.package_name} | {getMonthName(billing.period_month)} {billing.period_year}</p>
                        <div className="mt-1 flex flex-wrap items-center gap-1.5">
                          <span className={`px-2 py-0.5 rounded-full text-[10px] border ${engineState.tone}`}>
                            status_tagihan: {engineState.label}
                          </span>
                          <span className={`px-2 py-0.5 rounded-full text-[10px] border ${invoiceMeta.tone}`}>
                            tagihan: {invoiceMeta.label}
                          </span>
                          <span className={`px-2 py-0.5 rounded-full text-[10px] border ${paymentMeta.tone}`}>
                            pembayaran: {paymentMeta.label}
                          </span>
                          {overdueDays > 0 && String(billing?.status || '').toLowerCase() !== 'paid' ? (
                            <span className="px-2 py-0.5 rounded-full text-[10px] border border-red-500/30 text-red-300">
                              Tertunggak {overdueDays} hari
                            </span>
                          ) : null}
                        </div>
                        {pendingSubmission ? (
                          <div className="mt-1 inline-flex items-center gap-1 rounded-full border border-amber-400/30 bg-amber-500/10 px-2 py-0.5 text-[10px] text-amber-300">
                            Menunggu verifikasi transfer
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="flex items-center gap-4">
                      <div className="text-right">
                        <p className="text-white font-bold">{formatCurrency(billing.amount)}</p>
                        <p className="text-gray-500 text-xs">Jatuh tempo: {formatDate(billing.due_date)}</p>
                        {billing.payment_date && (
                          <p className="text-green-400 text-xs">Dibayar: {formatDate(billing.payment_date)}</p>
                        )}
                        {billing.payment_method && (
                          <p className="text-cyan-300 text-xs">Metode: {String(billing.payment_method).toUpperCase()}</p>
                        )}
                        {billing.payment_source && (
                          <p className="text-amber-300 text-xs">Sumber: {String(billing.payment_source).toUpperCase()}</p>
                        )}
                        {billing.payment_proof_url && (
                          <a
                            href={`${BASE_URL}${billing.payment_proof_url}`}
                            target="_blank"
                            rel="noreferrer"
                            className="text-xs text-indigo-300 hover:text-indigo-200 underline underline-offset-2 inline-flex items-center gap-1 mt-1"
                          >
                            <Paperclip className="w-3 h-3" />
                            Bukti pembayaran
                          </a>
                        )}
                      </div>
                      <span className={`px-3 py-1 rounded-full text-xs border whitespace-nowrap ${statusColors[billing.status]}`}>
                        {billing.status === 'paid' ? 'Lunas' : billing.status === 'unpaid' ? 'Belum Bayar' : 'Jatuh Tempo'}
                      </span>
                      <div className="flex gap-1">
                        <Button size="sm" variant="ghost" onClick={() => handleDownloadPDF(billing.id)} className="text-brand-blue hover:text-brand-blue-neon" title="Download PDF">
                          <FileText className="w-4 h-4" />
                        </Button>
                        {String(billing.status || '').toLowerCase() === 'paid' && (
                          <Button size="sm" variant="ghost" onClick={() => handleDownloadReceipt(billing.id)} className="text-indigo-300 hover:text-indigo-200" title="Download Kwitansi">
                            <Download className="w-4 h-4" />
                          </Button>
                        )}
                        {billing.status !== 'paid' && (
                          <>
                            <Button size="sm" variant="ghost" onClick={() => handleSendWhatsApp(billing.id)} className="text-green-400 hover:text-green-300" title="Kirim WhatsApp">
                              <Send className="w-4 h-4" />
                            </Button>
                            <Input
                              type="text"
                              value={billingPaymentNoteMap[billing.id] || ''}
                              onChange={(e) => setBillingPaymentNoteMap((prev) => ({ ...prev, [billing.id]: e.target.value }))}
                              placeholder="Catatan bayar (opsional)"
                              className="h-8 w-[170px] bg-[#0A0A0A] border-white/10 text-white text-xs"
                            />
                            <Input
                              type="file"
                              accept=".jpg,.jpeg,.png,.webp,.pdf"
                              onChange={(e) => setBillingPaymentBuktiFileMap((prev) => ({ ...prev, [billing.id]: e.target.files?.[0] || null }))}
                              className="h-8 w-[180px] bg-[#0A0A0A] border-white/10 text-white text-xs file:mr-2 file:rounded file:border-0 file:bg-white/10 file:px-2 file:py-1 file:text-[10px] file:text-white"
                            />
                            <Select
                              value={billingPaymentSourceMap[billing.id] || ((billingPaymentMethodMap[billing.id] || 'cash') === 'transfer' ? 'wa' : 'office')}
                              onValueChange={(value) => setBillingPaymentSourceMap((prev) => ({ ...prev, [billing.id]: value }))}
                            >
                              <SelectTrigger className="h-8 w-[120px] bg-[#0A0A0A] border-white/10 text-white text-xs">
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="office">Kantor</SelectItem>
                                <SelectItem value="wa">WA</SelectItem>
                                <SelectItem value="bank">Bank</SelectItem>
                                <SelectItem value="other">Lainnya</SelectItem>
                              </SelectContent>
                            </Select>
                            <Select
                              value={billingPaymentMethodMap[billing.id] || 'cash'}
                              onValueChange={(value) => setBillingPaymentMethodMap((prev) => ({ ...prev, [billing.id]: value }))}
                            >
                              <SelectTrigger className="h-8 w-[110px] bg-[#0A0A0A] border-white/10 text-white text-xs">
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="cash">Cash</SelectItem>
                                <SelectItem value="transfer">Transfer</SelectItem>
                              </SelectContent>
                            </Select>
                            <Button
                              size="sm"
                              onClick={() => handlePayment(billing.id, billingPaymentMethodMap[billing.id] || 'cash')}
                              disabled={payingBillingId === billing.id}
                              className="bg-green-600 hover:bg-green-700 text-white text-xs"
                            >
                              {payingBillingId === billing.id ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <Check className="w-3 h-3 mr-1" />}Bayar
                            </Button>
                            {pendingSubmission ? (
                              <>
                                {pendingSubmission.proof_file_url ? (
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    className="border-cyan-400/30 text-cyan-300 hover:bg-cyan-500/10 text-xs"
                                    onClick={() => window.open(`${BASE_URL}${pendingSubmission.proof_file_url}`, '_blank', 'noopener,noreferrer')}
                                  >
                                    <Paperclip className="w-3 h-3 mr-1" />
                                    Buka Bukti
                                  </Button>
                                ) : null}
                                <Button
                                  size="sm"
                                  className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs"
                                  onClick={() => handleSetujuiTransferSubmission(pendingSubmission.id)}
                                  disabled={processingTransferSubmissionId === pendingSubmission.id}
                                >
                                  {processingTransferSubmissionId === pendingSubmission.id ? <RefreshCw className="w-3 h-3 mr-1 animate-spin" /> : <Check className="w-3 h-3 mr-1" />}
                                  Setujui Cepat
                                </Button>
                                <Button
                                  size="sm"
                                  variant="outline"
                                  className="border-red-400/30 text-red-300 hover:bg-red-500/10 text-xs"
                                  onClick={() => handleTolakTransferSubmission(pendingSubmission.id)}
                                  disabled={processingTransferSubmissionId === pendingSubmission.id}
                                >
                                  Tolak
                                </Button>
                              </>
                            ) : null}
                          </>
                        )}
                        <Button size="sm" variant="ghost" onClick={() => handleDelete(billing.id)} className="text-red-400 hover:text-red-300">
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
        </div>
                  </PageContainer>
    </AppShell>

      {/* Create Billing Modal */}
      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
        <DialogContent className="billing-dialog-content bg-[#121212] border-white/10 text-white max-w-md">
          <DialogHeader>
            <DialogTitle className="font-outfit text-xl">Buat Tagihan Baru</DialogTitle>
          </DialogHeader>

          <form onSubmit={handleSubmit} className="space-y-4 mt-4">
            <div>
              <label className="staff-form-label">Pilih Pelanggan *</label>
              <Select value={formData.customer_id} onValueChange={(v) => setFormData({ ...formData, customer_id: v })}>
                <SelectTrigger className="bg-[#1a1a1a] border-white/10 text-white">
                  <SelectValue placeholder="Pilih pelanggan" />
                </SelectTrigger>
                <SelectContent className="bg-[#1a1a1a] border-white/10 max-h-60">
                  {customers.map(c => (
                    <SelectItem key={c.id} value={c.id} className="text-white">
                      {c.customer_id} - {c.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="staff-form-label">Bulan *</label>
                <Select value={formData.period_month} onValueChange={(v) => setFormData({ ...formData, period_month: v })}>
                  <SelectTrigger className="bg-[#1a1a1a] border-white/10 text-white">
                    <SelectValue placeholder="Bulan" />
                  </SelectTrigger>
                  <SelectContent className="bg-[#1a1a1a] border-white/10">
                    {months.map(m => (
                      <SelectItem key={m.value} value={m.value} className="text-white">{m.label}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <label className="staff-form-label">Tahun *</label>
                <Select value={formData.period_year} onValueChange={(v) => setFormData({ ...formData, period_year: v })}>
                  <SelectTrigger className="bg-[#1a1a1a] border-white/10 text-white">
                    <SelectValue placeholder="Tahun" />
                  </SelectTrigger>
                  <SelectContent className="bg-[#1a1a1a] border-white/10">
                    {[2024, 2025, 2026, 2027].map(y => (
                      <SelectItem key={y} value={y.toString()} className="text-white">{y}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div>
              <label className="staff-form-label">Jumlah (Opsional)</label>
              <Input 
                type="number" 
                value={formData.amount} 
                onChange={(e) => setFormData({ ...formData, amount: e.target.value })} 
                placeholder="Kosongkan untuk pakai harga paket"
                className="bg-[#1a1a1a] border-white/10 text-white" 
              />
            </div>

            <div className="flex gap-3 justify-end pt-4 border-t border-white/10">
              <Button type="button" variant="outline" onClick={() => setIsModalOpen(false)} className="btn-secondary">Batal</Button>
              <Button type="submit" className="btn-primary text-white">Buat Tagihan</Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      {/* Generate Monthly Modal */}
      <Dialog open={isGenerateModalOpen} onOpenChange={setIsGenerateModalOpen}>
        <DialogContent className="billing-dialog-content bg-[#121212] border-white/10 text-white max-w-sm">
          <DialogHeader>
            <DialogTitle className="font-outfit text-xl">Generate Tagihan Bulanan</DialogTitle>
          </DialogHeader>

          <div className="space-y-4 mt-4">
            <p className="text-gray-400 text-sm">Buat tagihan otomatis untuk semua pelanggan aktif</p>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="staff-form-label">Bulan</label>
                <Select value={generateMonth} onValueChange={setGenerateMonth}>
                  <SelectTrigger className="bg-[#1a1a1a] border-white/10 text-white">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-[#1a1a1a] border-white/10">
                    {months.map(m => (
                      <SelectItem key={m.value} value={m.value} className="text-white">{m.label}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <label className="staff-form-label">Tahun</label>
                <Select value={generateYear} onValueChange={setGenerateYear}>
                  <SelectTrigger className="bg-[#1a1a1a] border-white/10 text-white">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-[#1a1a1a] border-white/10">
                    {[2024, 2025, 2026, 2027].map(y => (
                      <SelectItem key={y} value={y.toString()} className="text-white">{y}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div className="flex gap-3 justify-end pt-4 border-t border-white/10">
              <Button variant="outline" onClick={() => setIsGenerateModalOpen(false)} className="btn-secondary">Batal</Button>
              <Button onClick={handleGenerateMonthly} className="btn-primary text-white">Generate</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AdminBilling;







































